function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawGettingCoffee = function UndrawGettingCoffee(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1097.1 808.51",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 571.46,
    y1: 826.07,
    x2: 571.46,
    y2: 298.08,
    gradientTransform: "matrix(.98 0 0 1.01 2.02 -2.01)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("ellipse", {
    cx: 531.81,
    cy: 747.63,
    rx: 430.64,
    ry: 60.88,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M11.85 389.01c17.36 67.13 54.11 125.16 112.18 153.29 120.71 58.46 392.92 28.31 596.07-6.3 105.07-17.9 197.44-67.27 264.54-136.82zM1077.2 73.02H965.73c-5.29 0-9.63-3.92-9.63-8.71s4.34-8.72 9.63-8.72H985c-5.3 0-9.63-3.92-9.63-8.71s4.33-8.72 9.63-8.72h-13.76c-5.3 0-9.63-3.92-9.63-8.71s4.33-8.72 9.63-8.72h58.18c-12.91-5.43-28-9.29-45.39-11.32-158.64-18.43-215.28-6.24-235.26 6.3a234.32 234.32 0 0 1-81.54 32.34c-97.88 18.27-280.93 40.25-446.84-7-82.46-23.54-143.74 16.2-180.48 82.55h1056.64c-1.38-19.29-5.51-37.11-13.09-52.69a10.23 10.23 0 0 1-6.26 2.11zM2.39 248.89a402.61 402.61 0 0 0 4.32 117.13l978.68 32.38a414.6 414.6 0 0 0 68-93.82zm387.08 83.55H370.2c5.3 0 9.64 3.93 9.64 8.72s-4.34 8.72-9.64 8.72H258.73c-5.29 0-9.63-3.93-9.63-8.72s4.34-8.72 9.63-8.72H278c-5.3 0-9.63-3.92-9.63-8.71s4.33-8.72 9.63-8.72h-13.76c-5.3 0-9.63-3.92-9.63-8.71s4.33-8.72 9.63-8.72h111.47c5.3 0 9.63 3.92 9.63 8.72s-4.33 8.71-9.63 8.71h13.76c5.3 0 9.63 3.93 9.63 8.72s-4.33 8.71-9.63 8.71zM1096.6 124.25L28.12 147.72c-13 30.23-21.57 64.41-25.57 99.83h1075.33a380.29 380.29 0 0 0 15.53-63.63c3.2-20.82 4.48-40.96 3.19-59.67zm-877.13 77H200.2c5.3 0 9.64 3.92 9.64 8.71s-4.34 8.72-9.64 8.72H88.73c-5.29 0-9.63-3.92-9.63-8.72s4.34-8.71 9.63-8.71H108c-5.3 0-9.63-3.93-9.63-8.72s4.33-8.71 9.63-8.71H94.24c-5.3 0-9.63-3.93-9.63-8.72s4.33-8.72 9.63-8.72h111.47c5.3 0 9.63 3.93 9.63 8.72s-4.33 8.72-9.63 8.72h13.76c5.3 0 9.63 3.92 9.63 8.71s-4.33 8.72-9.63 8.72z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M821.08 531.33l54.65-1.2-.86-7.8-71.37-4.13-.78-3.17c5.34-.18 11.57-.45 15.84-.85 0-.3 0-.63-.08-.94l1.19-.1c1.2-.12 2.25-.24 3.07-.38 6.92-1.14-.58-6.41 2.73-10.6s-.07-19.78.2-23.13-2.28-16.71-4.5-19.49-2.55-14.76-2.55-14.76-5.28-4.72-8.38-20.87-15.33-24.47-19.24-25.29-9.72-4.15-9.72-5-6.66-1.09-9.43-2.2-4.17-2.49-6.38-2.76a12.76 12.76 0 0 0 1.95-3 8.41 8.41 0 0 1 .8-1.24 6.57 6.57 0 0 1 .48-.57 3.08 3.08 0 0 1 3-1.15c.4.12.82.35 1.22.5l.31.09a1.15 1.15 0 0 0 .87-.09 1.43 1.43 0 0 0 .6-.86l.09-.35q.13-.63.21-1.26v-.09c.05-.43.08-.87.1-1.31.13-3.14-.32-6.4 1.13-9.14l.09-.13c1.46-2.62 4.33-4.08 6.68-6a17.82 17.82 0 0 0 1.37-1.24c.17-.17.33-.35.49-.52s.52-.54.75-.83.39-.49.58-.74l.52-.71c.21-.3.4-.6.59-.91l.36-.61c.2-.35.38-.71.56-1.07l.24-.51q.27-.6.51-1.23l.14-.38c.16-.46.31-.92.44-1.39v-.23a18.92 18.92 0 0 0 .56-3.06 19.84 19.84 0 0 0-4.63-14.52c-2.57-3-6.26-5.65-6.48-9.59a15.3 15.3 0 0 1 1.19-5.4 13.69 13.69 0 0 0 .58-2.33 7.61 7.61 0 0 0 .09-1.08c0-2.93-1.87-5.54-4-7.53a25.71 25.71 0 0 0-23.24-6.07c-2.15.52-4.3 1.34-6.5 1.07-2.54-.31-4.67-2-7-3.16-7.51-3.79-17.66-1-22.18 6.14-2.61 4.12-3.61 9.48-7.52 12.38-2.31 1.7-5.5 2.47-7.16 4.68a5.25 5.25 0 0 0-.51.81 6.28 6.28 0 0 0-.59 2.77v.73c0 .72.13 1.46.23 2.17a13.18 13.18 0 0 0 .93 3.45 12.5 12.5 0 0 0 1.72 2.86 19.83 19.83 0 0 0 1.6 1.79l.59.62.13.14a15.43 15.43 0 0 1 1.13 1.34l.06.08.31.45-.42.51a33.55 33.55 0 0 0 5.09 46.74c0 .35 0 .71-.05 1.07-.08 1.87-.2 3.84-.35 5.85a4.86 4.86 0 0 0-3.8-1.3 4.05 4.05 0 0 0-1.89.18 4.53 4.53 0 0 1-1.09.23c-1.42-.12-2.75-.62-4.15-.47a4.67 4.67 0 0 0-3.91 1.39c-2.74 2.55-12.31 5.87-16.94 6.16a2.57 2.57 0 0 1-1-.25 2.4 2.4 0 0 0-1.52-.13c-2.94-.64-11 5.09-12.86 8.54-1.93 3.63-8.27 13.41-8.27 13.41s-5.52 6.7-4.68 10.32-1.91 7.81-5.23 9.49-9.79 18.51-9.79 18.51 1.86 22.35-5.6 26.28c-1.87 1-2.92 3.16-3.44 5.87a16.73 16.73 0 0 0 1.61 11c.52 2.39 1.07 4 1.07 4l1.49-.36a17.93 17.93 0 0 0 6.69 4.63L593 515.47c-2.42-11.56-7.17-16-10.78-17.58C596 488.71 568 483.52 568 483.52l-50.76-1.6c1.86-1.51 2.86-3.31 2.57-5.06-.47-2.87-4.24-4.75-9.08-4.84h-.51v-3.8h-.12a1.82 1.82 0 0 0 .12-.65c0-2.85-6.64-5.23-15.72-6h-.29l-1.4-.1h-4.7a60.07 60.07 0 0 0-15.17 1.79c-1.22-3.82-9.57-8.18-9.57-8.18s-1.36-8.27-6-10.41-5.44-9.36-5.06-12.9c.18-1.64-3-6.27-6.94-10.72l-1.91-11.51a17.27 17.27 0 0 0-2.56-2.76 20.25 20.25 0 0 0-3.31-9.69 36.56 36.56 0 0 0 18.09-61.37l-.94-.91c3.54-1.9 6.73-4.2 8.24-7.38a5.42 5.42 0 0 0 .48-1.6c.5-3.75-3.1-7.58-6.93-8.9-4.37-1.5-9.26-1.23-13.47-3.15-7.21-3.27-10.63-12-17.67-15.65-5.47-2.83-12-2-18.06-.73-8.89 1.92-19.1 6.43-20.42 15.48-.6 4.07.82 8.41-.62 12.27-3.7 9.88-20.63 6.53-26.28 15.44a19.8 19.8 0 0 0-2.29 7.35q-2.88 16.75-5.77 33.52c-.8 4.61-1.65 9.36-4.21 13.25-2.67 4.07-6.85 6.69-11.31 8.79-4.16-5.54-10.61-7.53-15.91-8.16a4 4 0 0 1 .43-.28s-25.7-2.66-35.51 7.28c0 0-3 12.06 4.33 14.62 3.26 1.14 9.85 0 16.14-1.54a60.6 60.6 0 0 0-1 29.16c.83 3.93 2.06 8 .85 11.86-1 3.3-3.71 5.76-6 8.33a49.63 49.63 0 0 0-10.75 19.41c-1.54 5.39-1.88 11.93 2.09 15.87a11.56 11.56 0 0 0 6.59 3h-.11a35.21 35.21 0 0 0 9.17-.11c5.71-.64 11.89-1.5 16-5.54 2.23-2.21 3.6-5.13 4.91-8q4.13-8.92 8.23-17.85c.78-1.7 1.6-3.42 2.48-5.14 3.64 19.24 7.41 38.13 7.41 38.13h3.84l.62 10.27c-4.37 1.87-5.64 3.77-5.19 5.54-5.14 3.41-11 10.64-10.34 25.8-1.46.2-2.91.44-4.37.73-54.06 10.69-87.06 74.7-73.71 143s68 114.95 122.07 104.27c42.06-8.32 71.37-48.92 76-98.69 14.53 9 31 12.69 47.45 9.44a60.59 60.59 0 0 0 11.06-3.3l.07 20.24-4.45 22.84c-18.33.22-33.09 18-33 39.92s15.08 39.77 33.53 39.71 33.33-17.94 33.26-39.94c-.06-16.28-8.3-30.25-20.06-36.38l-.76-.37c1.72-13.87 2.84-25.82 2.84-25.82l-.09-26.22a74 74 0 0 0 22.16-23.82h2.8s5.78.23 7.53 9.05c.74 3.75 7 20.3 13.92 38.08a41.58 41.58 0 0 0-.56 6.94c0 13.12 6.23 24.49 15.3 30.27l3.59 8.94-1.35.69s3.19 21.91 10.41 22.11c3 4.64 8.3 11.94 11.54 10.74l23.19-5.18.77-.06 23.75-5.7s2.47-1.57 6-4l5.23 41.54 10 .8 5.34-1.24 6.84-1.58 6.47-53.57c6.63-3.65 12.25-7.85 14.6-12.35 3.83-7.33-3.07-11-11.58-12.6l1-8.31c3.12-2.28 6-4.49 8.2-6.21a23.78 23.78 0 0 1-.7 3.8c-1.37 4.47-6.06 10.61 6.69 13.36s21.34.2 21.89-2 3.29-11.16 1-16.16-3.11-18.11 1-25.64 1.32-19.24-2.56-20.62c-2.58-.91-6.37-2.55-8.63-3.56-.24-.3-.48-.61-.74-.92a18.76 18.76 0 0 1 6-5.26c6.64-3.36 5.23-10.88 5.23-10.88s6.93 0 11.89-8.4c3.47-5.87 7.49-11.74 9.58-16 .43 2.69.92 6 1.2 8.88.58 5.94 7.61 63.69 10.77 68.51s.63 23 .63 23h10.16l-.83-27.86s-11.74-81.89-2.16-90.28c1.41-1.24 2.79-2.5 4.12-3.75l22.7 174.31 9.78.34 4.64.16-1.43-172.12zm-277.86 127c-7.33-.33-15-.57-18.7-.67l-.07-19.88h-6.11a118.06 118.06 0 0 0 32.89-8.06 90.35 90.35 0 0 1-8.01 28.62zM418.43 749.8l-50.67-66-1.4-1.83c.25-.65.48-1.31.68-2l1.95.35 71.6 12.86 2.86.52c-2.32 22.74-10.46 43.27-23 58.75zm17-70.8l-65.48-7.87-2-.23a28.18 28.18 0 0 0-.4-3 25.82 25.82 0 0 0-3.06-8.11l1.44-1.4 22.44-22 24.29 1.61a109.84 109.84 0 0 0 22.73 41zm-11-273.46a20 20 0 0 0-1.8 6.1h-.13a12.58 12.58 0 0 1 .39-2.12 24.93 24.93 0 0 1 1.53-3.98zm169.83 136.22c.25-4.29.31-8.16.23-11.68l37.46 1.5 6.64 52.72c-4.22 3.9-7.09 6.64-7.09 6.86 0 .6-7 12.5-4.58 26.37a21.85 21.85 0 0 0-1.52-1.74c-1.11-6.12-2.13-10.51-2.91-11.57-3.38-4.59-1.2-30.5-1.2-30.5s-5.94-16.73-13.57-22.28C606 550.15 601.31 549 595 548a51.29 51.29 0 0 0-.74-6.24zm74.55 144.82l-2.67-22.31c5.61 5 10.9 9.53 15.14 13.13-2.82 2.6-7.79 6.92-12.47 9.18zM463.92 532.74c-.08-.16-.15-.29-.23-.42 3.26-.51 6-1 8.26-1.59a19.84 19.84 0 0 1 2.48 2zm203.47 18.73c-4.69 6.15-5.23 10-5.23 10l1.19.26-8.53 7.7-4.43-37.16 20.85.84c-1.14 9.29-2.45 16.53-3.85 18.36zM635 634.06c3.16 3.62 7.08 7.68 11.37 11.87l3.29 26.12-17.12-41.16a36.63 36.63 0 0 0 2.46 3.17zM651.09 705a6.34 6.34 0 0 1-1.12 1.32c-9.3-6.2-15.89-20.85-18.84-28.53 1.64-1.17 2.63-2 2.63-2s-1.06-9-2.57-20.56c8.41 18.49 17.62 39.09 22.55 50.16-1.62-.25-2.65-.39-2.65-.39zm36.8-76.11s4.3-1.06 9.9-2.67l-1.73 13.42c-5.06-6.56-8.17-10.78-8.17-10.78zm74-239.51a8 8 0 0 0-.93.67c-.3-.74-.58-1.51-.85-2.28a6.22 6.22 0 0 0 1.2 1.25 3.5 3.5 0 0 0 .62.33zm-86.51 92.37l.14-.34v.36zm131.4 49.92l3.15-.07-.13 12.12c-.9-3.72-1.92-7.8-2.98-12.08zm-220.33.68l-65 .22a84.15 84.15 0 0 0-8-5.69l73.09 2.92q.04 1.38-.05 2.52zM434.16 405.63c-2 1.63-3.83 3-5.19 3.93a23.07 23.07 0 0 1-4.51-4.1l.45-.91a61.35 61.35 0 0 1 3.22-5.47l.84-1.25h1.44a13.69 13.69 0 0 1 4.38 7.37 4.6 4.6 0 0 0-.63.43zm-88 153.94v-.18zm8.31 68a7.63 7.63 0 0 0 7.07 6.95l15.27 1.05L362 653.34l-1.29 1.55a21.46 21.46 0 0 0-8.22-5.15l.19-2.16zM444 674.73a87.4 87.4 0 0 1-7.19-8.18l5.78-6.84a138.48 138.48 0 0 1 1.41 15.02zm-14.13-18.51a101.74 101.74 0 0 1-8-17.55l16.32 1.11c.71 2.38 1.37 4.8 2 7.25zm62.19-18.32h4.61zm214.21 59c.63.49 1.2 1 1.71 1.37-.34 3.16-.63 8.53.68 12.42l.06.2-4.23.74zM809 615.69l-.85 75.69-10.7-70.22c2.91-1.43 7.45-3.56 11.55-5.47zM573.65 502c1.42-.54 2.7-1.07 3.85-1.59 4.52 3.93 6.91 9.59 8.1 15.26L502.93 518l-.2 3.15a67.81 67.81 0 0 0-13-4l-.38-.25c-5.42-3.43-13.34-8-20.19-11.95a16.17 16.17 0 0 0-.58-4.56 1.16 1.16 0 0 1 0-.18c1.92-.73 3.82-1.41 5.49-2a36 36 0 0 0 14.39 2.79 39.07 39.07 0 0 0 8.3-.92zm-63-28c3.16.21 5.56 1.51 5.88 3.45.2 1.25-.51 2.53-1.83 3.61a36.87 36.87 0 0 0-6.11-1.39 20.78 20.78 0 0 0 1.55-5.67h.46zM323.3 408.46a23.65 23.65 0 0 1-3 .51l-.21-.51a21.32 21.32 0 0 1 3.21 0zm27.06 116.7l.61.31 1.21 20.1a83.52 83.52 0 0 0-8.81-.2c-.1-5.62.63-15.78 6.99-20.21zm-17.21 35.57c.92-.19 1.85-.34 2.78-.49l2.55 35.57s.37 13.49 7.62 16.57V648.76a19.09 19.09 0 0 0-3.09.34 17.08 17.08 0 0 0-1.74.45l-1.33-1.85-44.35-62-2-2.77c10.79-11.29 24.21-19.17 39.56-22.2zM327 660.38l-58.58-9.86-2.86-.48c1.71-21.28 8.48-40.74 19.15-56.14l2.08 2.67 44.44 57 1.29 1.66a21.92 21.92 0 0 0-3.49 5.46zm-61.82 4l2.86.27 56.95 5.2 1.92.17a26 26 0 0 0 .48 5.85 25.49 25.49 0 0 0 4.73 10.61l-1.47 1.32-44.87 40.28-2.22 2a136.77 136.77 0 0 1-15.8-42.42 142.23 142.23 0 0 1-2.63-23.29zm27.52 79.3l2-2.35 41-48.54 1.32-1.56a19.64 19.64 0 0 0 10.79 3.77v2.15l.27 79.46v3.54c-20.93-4.15-40.53-17.25-55.43-36.48zm83.42 36.54a70.58 70.58 0 0 1-12.55 1.33l-.31-3.55-7-82.39-.2-2.27a19 19 0 0 0 4.6-3l1.21 1.74L409 759.74l2 2.81a73.47 73.47 0 0 1-34.93 17.66zm76.38-129.1c-.17-.84-.34-1.67-.52-2.51l6.3-7.45 20.5 1.4.17 51.7a64.3 64.3 0 0 1-23.52-10 157.48 157.48 0 0 0-2.93-33.14zm47.7 43.18a53.39 53.39 0 0 1-9.54 1l-4.26-50.06 16.52 1.53 10.26 14.73.1 28.41a54 54 0 0 1-13.08 4.39zm24.39-16.42l2.09 3c-.68.61-1.37 1.22-2.08 1.8zm9.34-4.64l-1.84-2.39c1.13.14 2.27.26 3.4.36-.49.69-1.03 1.37-1.56 2.03zm31.54 2.94s-4.3-12.5-12.7-16.43a104.74 104.74 0 0 0 7.54-34.08c3.47-1.73 6.68-3.53 9.64-5.34 1.06 15.5 6.1 60.63 13.11 67.08a22.88 22.88 0 0 1 4.47 6.83 30.65 30.65 0 0 0-11.33 10.84zm31.11 83.73a23 23 0 0 0 2.51.16l-2.07 1zm113.25-36.7l-6.78.57.3-2.48c2.41-.1 4.94-.25 6.72-.44v2.55z",
    transform: "translate(-51.45 -45.75)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M377.1 505.3l40.24 51.73-4.13 1.62-51.4-8.78v11.06l53.62 5.06 1.91 9.9-42.19 37.42 7.48 10.41 44.25-51.73v81.99h12.04l-6.84-83.29 3.58 8.95 41.3 59.37 7.59-7.48-45.63-59.52-3.26-4.25 4.88 1.95.49 3.42 60.68 11.06.87-10.43-63.26-7.77-.97-6.77 47.25-45.79-7.48-8.13-43.84 51.89-4.15-2.36 7-75.15-11.15-1.3-.32 76.94-3.09-4.39-38.8-54.34-6.67 8.71z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M377.1 505.3l40.24 51.73-4.13 1.62-51.4-8.78v11.06l53.62 5.06 1.91 9.9-42.19 37.42 7.48 10.41 44.25-51.73v81.99h12.04l-6.84-83.29 3.58 8.95 41.3 59.37 7.59-7.48-45.63-59.52-3.26-4.25 4.88 1.95.49 3.42 60.68 11.06.87-10.43-63.26-7.77-.97-6.77 47.25-45.79-7.48-8.13-43.84 51.89-4.15-2.36 7-75.15-11.15-1.3-.32 76.94-3.09-4.39-38.8-54.34-6.67 8.71z"
  }), React.createElement("path", {
    d: "M506.55 551.61c-10-51.63-51.37-87.05-92.48-79.11s-66.35 56.22-56.38 107.85 51.37 87 92.48 79.12 66.38-56.22 56.38-107.86zm-58.41 97.36c-36.49 7-73.24-24.4-82.09-70.23s13.56-88.7 50.05-95.75 73.24 24.4 82.09 70.24-13.57 88.7-50.06 95.74z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M506.55 551.61c-10-51.63-51.37-87.05-92.48-79.11s-66.35 56.22-56.38 107.85 51.37 87 92.48 79.12 66.38-56.22 56.38-107.86zm-58.41 97.36c-36.49 7-73.24-24.4-82.09-70.23s13.56-88.7 50.05-95.75 73.24 24.4 82.09 70.24-13.57 88.7-50.06 95.74z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 478.11,
    cy: 612.79,
    rx: 15.57,
    ry: 17.54,
    transform: "rotate(-10.93 213.242 858.703)",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M589.21 700.09v9.16s39.41-4.71 43.48-6.63 28.48-19.39 28.48-20.62-3.42-3.59-3.42-3.59L613 682z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M589.21 700.09v9.16s39.41-4.71 43.48-6.63 28.48-19.39 28.48-20.62-3.42-3.59-3.42-3.59L613 682z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M592.3 717.69h3.25s40-10.5 38.34-1.29-28.49 25.9-28.49 25.9l-23.77 5.59-16 1.28-9.53-2.83-5.64-7.66z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M644.04 668.39l15-2.57s3.64 9.3.86 10-15.85.91-15.85.91zM497.4 554.43h63.35v72.2h-9.81v-63.68l-57.79-2.41 4.25-6.11zM526.13 452.89s19.55-2.7 16.63 44.63l-8.21-5.78s5.25-31-14-38.85z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M536.41 488.1H394.63l7.28 36.62 139.64 9.43s7.28-44.12-5.14-46.05z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M282.01 377.34s3-15.39-14.6-13.24-6.86-13.28-6.86-13.28 29.54-4.51 29.12 23.44-7.66 3.08-7.66 3.08zM365.93 350.55s18-3.16 18.42 15.69h5.57s3-21.42-24-22.7zM297.82 452.34l4.29 75.39 5.14-3v-76.25l-9.43 3.86zM394.63 429.64l7.52 50.8 7.04-4.11-7.28-50.98-7.28 4.29z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M401.91 455.76s12.85-10.28 24.85-7.28l1.71 3.37s-23.56 7.34-24.42 10.76z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M294.4 374.81s-15-3.86-13.71 9 13.71 75.82 13.71 75.82h12.85v65.1l96.8-27.2-6.85-61.46h6.85l-11.56-70.68s-5.14-7.28-9.42-3.85a92.6 92.6 0 0 1-7.71 5.56zM234.43 357.67s-3 12 4.29 14.57 31.26-6 31.26-6-6.42-12.1 0-15.69c0 0-25.7-2.73-35.55 7.12zM338.95 347.39s-5.65 14.44 3.38 13.22 29.22-6.57 29.22-6.57-3.43-11.79 0-13.5c0 0-24.89.85-32.6 6.85zM404.05 500.74l-92.52 34.7 14.99 26.98 82.67-30.84-5.14-30.84zM443.03 436.91l73.68 2.57s36.4 6.86 5.56 18.42l-93.8-2.65s-27.84-15.77 14.56-18.34zM398.27 543.12c1.07.66 142.64 9.23 142.64 9.23l.64 4.9s-37.69 42-98.95 35.33-61.68-8.56-61.68-8.56z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M398.27 543.12c1.07.66 142.64 9.23 142.64 9.23l.64 4.9s-37.69 42-98.95 35.33-61.68-8.56-61.68-8.56z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M437.03 592.83h35.55v83.53h-11.35v-73.68l-29.12-2.78 4.92-7.07z"
  }), React.createElement("path", {
    d: "M490.36 738.67c0 21.89-15 39.63-33.41 39.63s-33.4-17.74-33.4-39.63 15-39.61 33.41-39.61h.66a28.84 28.84 0 0 1 12.81 3.34c11.73 6.15 19.93 20.08 19.93 36.27z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M470.42 702.41c-2.33 18.35-5.8 40.5-9.07 42.48-5.68 3.42-12.32 5.35-11.89-4.93l8.15-40.89a28.84 28.84 0 0 1 12.81 3.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M448.81 738.68l12.43-62.33h11.31s-6.21 63.83-11.89 67.25-12.27 5.36-11.85-4.92z",
    fill: "#d4dfec"
  }), React.createElement("ellipse", {
    cx: 547.23,
    cy: 680.51,
    rx: 28.88,
    ry: 34.25,
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M540.2 680.51l10.74-53.88h9.81s-5.37 55.17-10.27 58.14-10.65 4.62-10.28-4.26zM470.23 612.53s-9 7.28 0 10.92 27.42 3.18 27.42 3.18 5.78.25 7.49 9 33.63 88 33.63 88l7.49-3.86-32.77-88.67s-5.78-16.91-17.13-17.56-26.13-1.01-26.13-1.01zM543.91 738.68s9 16.06 13.7 14.35 1.5-10.5 1.5-10.5l-8.64-7.07zM581.6 732.25l17.13-4.92s8.14 11.35 1.93 14.35-19.06 4.66-19.06 4.66z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M535.77 720.25s3.11 21.81 10.33 22 49.45-24.56 49.45-24.56-6.64-22.7-10.49-21.42-49.29 23.98-49.29 23.98z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M550.47 736.83l35.85-5.93s-3.79 11.54 1.85 15.44l-30.56 6.69zM611.49 660.36s-31.06 17.6-30.84 19 4.92 24.13 8.14 24.35 30.41-23.13 30.41-23.13z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M613.41 672.76l32.56-6.94s-.22 11.92 2.35 13.56L613 685.83z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M537.81 563.87s-.78 6.21 1.72 6.43 18.2-2.57 22.06 2.78 43.69 95.52 43.69 95.52l7.46-4.94-37.52-90.58s-13.21-17.99-37.41-9.21z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M324.23 359.76l1.51 1.61 27.06 28.94 4.89 5.23 4.88 1.49 22 6.72s-3.79-26.61-11.58-32a3.78 3.78 0 0 1-1.6-2.67 9.09 9.09 0 0 1 .37-3.69 26.47 26.47 0 0 1 2.05-4.95 61.12 61.12 0 0 1 3.24-5.43l.84-1.24a133 133 0 0 1 9.49-12.08s-4.78-4-10.76-8.59c-10.51-8.09-24.71-18.08-23.16-11.73.79 3.21-2 8.33-6 13.8-.16.21-.32.43-.49.64a152.29 152.29 0 0 1-10.91 12.44c-6.27 6.52-11.83 11.51-11.83 11.51zM577.45 628.08s9.58 31.15 25.39 35.69 35.48-.68 35.48-.68 5.66 15.67-2.2 19.47-36-.83-41.49 1-19.82 9.4-19.82 9.4-3.71-14.32-3.28-21.06-5.98-38.65-5.98-38.65z",
    fill: "#c37098"
  }), React.createElement("path", {
    d: "M587.8 670.96s11.18-10.22 11.25-10.85c0 0 19.2 3.13 23.78 2.68s37.27-2.25 27.81 11.39-65 21.43-65.63 21.52-9.18-6.75-7.75-13 4.9-11.89 10.54-11.74z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M415.55 500.04l16.31 5.88s21 1.72 38.67-3.23 78-1 85.65 4.5 13.49 22.22 13.49 22.22-2.26 25.77 1.1 30.35 11 71.24 11 71.24-14.76 11.91-25.62 10.69-33.6-98.37-33.6-98.37L409.9 527.25z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M547.1 677.84l10.67 13.41 8.43 10.62s1.83 7.48 4.55 15.27c2.78 8 6.47 16.29 10 17.18 7.08 1.77 47-8 47-8s-2.64-21-24.22-26a25.1 25.1 0 0 1-3.48-1.08c-12.5-4.84-19.89-18.61-23.35-27.41-1.79-4.57-2.52-7.8-2.37-7.79z",
    fill: "#c37098"
  }), React.createElement("path", {
    d: "M570.75 717.16c2.78 8 6.47 16.29 10 17.18 7.08 1.77 47-8 47-8s-2.64-21-24.22-26a25.1 25.1 0 0 1-3.48-1.08c-5.69 5.34-25.06 15.67-29.3 17.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M570.49 718.31s31.43-16.34 31.74-20.5c0 0 19.24 2.81 25.23 1.31s40.09-1.21 32.46 13.13-49 25.56-49 25.56-38.49 4.49-40.19 2.36-.24-21.86-.24-21.86z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M415.45 440.86s2.61 1.28 6.69 3c13.06 5.58 41.24 16 47.56 4.73 8.29-14.75-25.3-15-29.1-12.83-2 1.13-5.64 0-8.65-1.44a46.32 46.32 0 0 1-4.95-2.68z",
    fill: "#c37098"
  }), React.createElement("path", {
    d: "M346.93 335.79a36.23 36.23 0 0 0 28 19c.72.08 1.44.14 2.15.18a130.12 130.12 0 0 1 10.33-13.32s-36.35-30.29-33.92-20.32c.79 3.35-2.21 8.75-6.56 14.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M343.05 313.39a36.24 36.24 0 0 0 32 40.14c.95.11 1.9.18 2.84.22a36.3 36.3 0 1 0-34.84-40.36z",
    fill: "#c37098"
  }), React.createElement("path", {
    d: "M415.45 440.86s2.61 1.28 6.69 3c3.22-4.12 7.55-7.56 9.81-9.54a46.32 46.32 0 0 1-4.95-2.68zM371.76 365.37a26.47 26.47 0 0 1 2.05-4.95l-.31-.38a19.48 19.48 0 0 0-1.74 5.33zM324.23 359.76l33.46 35.78 26.86 8.21s-3.79-26.61-11.58-32a3.78 3.78 0 0 1-1.6-2.67c-.35 12.67 8 26.34 8 26.34s-2.59 0-5.8-8.73-25.45-32.3-29.31-35.32c-1.39-1.09-4.3-2.3-8.2-3.11-6.27 6.51-11.83 11.5-11.83 11.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M373.36 361.32s4.68 5.81 8.9 5.64 19.41 17.06 19 20.57.41 10.72 5 12.85 5.94 10.37 5.94 10.37 11 5.77 9.56 9.81 8.42 11.3 10.3 11.84-18.19 12.17-14.94 23.52-8.46 26.21-5.17 31.43 14.55 41.24 10.15 43-108-2.82-108-2.82 3.62-47.59.41-56.36-4.61-62.27-7-70-14.93-42.42 1-49 31.65-2.57 35.51.46 26.1 26.54 29.31 35.31 5.8 8.74 5.8 8.74-12.86-21.29-5.77-35.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M422.77 514.91s47.55-.28 49.95-1.46 53.65-5.58 68.78 5 22.22 33.7 22.22 33.7l3.29 42.4 12 72.33s-20.46 30.14-28.67 20.86c-2.86-3.23-9.66-38.92-17.86-46.47s-13.5-68-13.07-71.79c0 0-7.48-2.46-13 .31s-87.88 2.36-88.35 2.3-23.48-54.05-23.48-54.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M547.1 677.84l10.67 13.41c7.24-3.86 15.74-14.95 18.95-19.38-1.79-4.57-2.52-7.8-2.37-7.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M421.35 516.05s47.55-.29 49.95-1.47 53.65-5.58 68.78 5 22.22 33.71 22.22 33.71l3.29 42.4 12 72.32s-20.48 30.12-28.71 20.84c-2.87-3.23-9.66-38.91-17.86-46.47s-13.5-68-13.07-71.79c0 0-7.48-2.46-13 .31s-87.81 2.35-88.29 2.35-23.47-54.06-23.47-54.06z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M310.87 404.85c4.76 0 9.61 1.13 14.42.95 10.93-.39 19.87-7.21 27.51-15.49 1.13-1.21 2.24-2.47 3.31-3.74 1.89-2.24 3.7-4.52 5.44-6.77 1.59-2.06 3.28-4.41 3-7-.18-1.71-1.21-3.19-1.93-4.75-2.53-5.53-1-11.82 1.9-17.35a40.83 40.83 0 0 1 2.85-4.64c3.05-4.32 6.65-8.43 9.27-13a26.87 26.87 0 0 0 2.92-7c.94-3.74.88-7.66 1.65-11.44a26.18 26.18 0 0 1 13.42-17.75c2.87-1.55 6.77-3 10.36-4.89a36.3 36.3 0 0 0-57.55 43.17c-.16.21-.32.43-.49.64a152.29 152.29 0 0 1-10.89 12.46c-6.27 6.53-11.83 11.52-11.83 11.52l1.51 1.61c-6.7 2.58-10.66 9.31-13.35 14.51-1.99 3.83-2.26 15.6-1.52 28.96z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M300.82 472.41s-21.41 2.63-17.13 34.32l3 43.69s.43 17.56 11.14 17.14-5.86-63.4-5.86-63.4-2.71-22.27 10.57-25.7zM444.32 592.83h-7.29l-1.15-73.64-.13-8.06s-7.72-25.38-20.56-27.1 4.31-6 4.31-6 24.39 7.49 24.82 33.09 0 81.71 0 81.71z",
    fill: "#d4dfec"
  }), React.createElement("path", {
    d: "M315.82 465.61l86.09 3.43s57.4 12.42 7.28 19.06l-101.94-4.5s-35.98-10.71 8.57-17.99z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M441.32 526.49v63.09a7.55 7.55 0 0 1-.73 3.25h-3.56l-1.15-73.64a7.62 7.62 0 0 1 5.44 7.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M310.64 511.64l122.91 7.89a7.62 7.62 0 0 1 7.13 7.6v63.12a7.62 7.62 0 0 1-8.16 7.6l-122.91-8.8a7.61 7.61 0 0 1-7.07-7.6v-62.2a7.62 7.62 0 0 1 8.1-7.61z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M395.35 635l-1.15 13.73-5.7-1.04-71.58-13.05-2.61-.47-.64-4.5-6.42-2.57 4.28 5.59 4.15 5.41 50.46 65.82 5.47 7.13-9.99 9.86-4.96-7.13-46.95-67.51-2.46-3.53-4.71-11.78 1.54 18.82 6.73 82 .72 8.83h-15.85V632.67L283.5 646.9l-41.18 48.15-4.89 5.72-9.86-13.7 5.89-5.23 45.03-39.92 4.64-4.11-2.52-13.05-7.73-.72-56.95-5.37-5.92-.56v-14.57l6.35 1.09 58.57 10.01 2.76.47 5.44-2.14-3.95-5.07-44.25-56.9-4.78-6.14 8.78-11.46 4.86 6.81 44.16 61.85 2.06 2.88 4.06 5.78.04-9.73.36-83.24.03-8.33 14.67 1.71-.73 7.86-7.72 83-.75 8.09 5.46 3.1 4.58-5.43 48.98-57.97 4.15-4.92 9.86 10.71-5.54 5.36-53.52 51.86-3.16 3.07 1.28 8.9 5.81.72 71.37 8.77 6.11.75z"
  }), React.createElement("path", {
    d: "M389.24 634.25a131.73 131.73 0 0 1-.73 13.43l5.69 1 1.15-13.72zm-30.25-84.47a111.46 111.46 0 0 1 8.47 11.15l5.54-5.37-9.85-10.7zm-2.33 164l5 7.13 10-9.85-5.47-7.13a81.17 81.17 0 0 1-9.53 9.84zm-61 16.58v10.25h15.89l-.72-8.83a70.47 70.47 0 0 1-15.15-1.43zm13.5-219.22l-14.61-1.73v8.33a71 71 0 0 1 14 1.24zm-79 33.73l4.78 6.14a86.25 86.25 0 0 1 8.85-10.76l-4.86-6.82zm-2.61 142.19l9.85 13.71 4.89-5.72a117 117 0 0 1-8.86-13.21zm-17.56-83.52v14.56l5.91.56a127.94 127.94 0 0 1 .44-14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M400.55 605.84c-13.12-68-67.64-114.61-121.76-104.16s-87.35 74-74.22 142 67.64 114.57 121.76 104.16 87.36-74.02 74.22-142zm-76.9 128.18c-48 9.28-96.43-32.12-108.08-92.46s17.85-116.79 65.89-126.06 96.45 32.12 108.09 92.46-17.84 116.79-65.89 126.06z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M313.67 629.67l-6.42-2.57 4.28 5.58 4.15 5.41a23.4 23.4 0 0 1-6 8.18l-2.46-3.54-4.67-11.78 1.54 18.82a20 20 0 0 1-8.4 1.52v-18.63l-12.14 14.24a24.72 24.72 0 0 1-5-5l4.64-4.11-2.51-13-7.73-.73a26.39 26.39 0 0 1 2-9.4l2.76.47 5.44-2.14-3.95-5.07a20.74 20.74 0 0 1 8.77-5.84l2.06 2.88 4.07 5.78v-9.72a20.15 20.15 0 0 1 6.61 1l-.75 8.09 5.46 3.1 4.59-5.42a26.13 26.13 0 0 1 3.92 5l-3.16 3.06 1.29 8.91 5.8.71a27.26 27.26 0 0 1-.95 9.17l-2.6-.47z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 346.85,
    cy: 671.9,
    rx: 20.5,
    ry: 23.1,
    transform: "rotate(-10.93 81.96 917.816)",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M459.78 444.99c0 5.81-10.17 11.64-22.72 11.64s-22.73-5.83-22.73-11.64 10.17-9.42 22.73-9.42 22.72 3.6 22.72 9.42z",
    fill: "#e8eaf2"
  }), React.createElement("path", {
    d: "M459.78 444.99c0 5.81-10.17 11.64-22.72 11.64s-22.73-5.83-22.73-11.64 10.17-9.42 22.73-9.42 22.72 3.6 22.72 9.42z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 437.05,
    cy: 444.99,
    rx: 22.73,
    ry: 10.53,
    fill: "#e8eaf2"
  }), React.createElement("ellipse", {
    cx: 437.12,
    cy: 445.39,
    rx: 13.56,
    ry: 5.46,
    opacity: 0.05
  }), React.createElement("path", {
    d: "M468.55 432.69c-.46-2.85-4.23-4.74-9.06-4.84a21.35 21.35 0 0 0-3.84.27c-6.54 1.05-11.38 4.81-10.81 8.39.46 2.83 4.16 4.7 8.92 4.84a21 21 0 0 0 4-.26c6.5-1.06 11.34-4.84 10.79-8.4zm-11.13 6.56a15 15 0 0 1-2.07.19c-3.79.1-6.83-1.29-7.18-3.47-.41-2.57 3.06-5.26 7.75-6a15.61 15.61 0 0 1 3.37-.16c3.16.21 5.57 1.52 5.88 3.44.38 2.55-3.06 5.24-7.75 6zM447.99 444.45a2.45 2.45 0 0 1-.56 1.5c-1.42 1.87-5.42 3.22-10.13 3.22-4.39 0-8.16-1.17-9.81-2.84a2.71 2.71 0 0 1-.88-1.88c0-2.61 4.79-4.72 10.69-4.72s10.69 2.11 10.69 4.72z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M447.99 444.45a2.45 2.45 0 0 1-.56 1.5 20.52 20.52 0 0 1-9.09 2.11h-2.57a20.63 20.63 0 0 1-8.28-1.73 2.71 2.71 0 0 1-.88-1.88c0-2.61 4.79-4.72 10.69-4.72s10.69 2.11 10.69 4.72zM459.46 427.85c0 .65-.08 1.3-.17 1.94a15.61 15.61 0 0 0-3.37.16c-4.69.76-8.16 3.45-7.75 6 .35 2.18 3.39 3.57 7.18 3.47a19.69 19.69 0 0 1-1.62 1.91c-4.76-.14-8.46-2-8.92-4.84-.57-3.58 4.27-7.34 10.81-8.39a21.35 21.35 0 0 1 3.84-.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M415.12 424.12v2.94a20.65 20.65 0 0 0 20.65 20.65h2.57a20.65 20.65 0 0 0 20.65-20.65v-2.94z",
    fill: "#65617d"
  }), React.createElement("ellipse", {
    cx: 436.95,
    cy: 423.47,
    rx: 22.03,
    ry: 6.27,
    fill: "#65617d"
  }), React.createElement("ellipse", {
    cx: 437.05,
    cy: 423.08,
    rx: 20.89,
    ry: 5.67,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 437.12,
    cy: 422.87,
    rx: 20.4,
    ry: 5.67,
    fill: "#fdf9f9"
  }), React.createElement("path", {
    d: "M422.2 424.38a.58.58 0 1 1 .58-.58.58.58 0 0 1-.58.58zm0-.94a.36.36 0 0 0-.36.36.37.37 0 0 0 .36.37.38.38 0 0 0 .37-.37.37.37 0 0 0-.37-.36zM422.87 423.17a.58.58 0 1 1 .57-.57.58.58 0 0 1-.57.57zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.35zM422.2 421.34a.58.58 0 1 1 .58-.57.58.58 0 0 1-.58.57zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM426.42 425.6a.58.58 0 1 1 .57-.57.57.57 0 0 1-.57.57zm0-.94a.37.37 0 0 0-.36.37.36.36 0 0 0 .72 0 .37.37 0 0 0-.36-.37zM443.35 424.47a.58.58 0 0 1-.58-.57.58.58 0 1 1 .58.57zm0-.94a.37.37 0 0 0-.37.37.37.37 0 0 0 .73 0 .37.37 0 0 0-.36-.37zM447.1 425.95a.57.57 0 0 1-.57-.57.58.58 0 0 1 .57-.57.57.57 0 0 1 .57.57.56.56 0 0 1-.57.57zm0-.93a.36.36 0 0 0-.36.36.37.37 0 0 0 .36.37.38.38 0 0 0 .37-.37.37.37 0 0 0-.37-.36zM447.23 423.53a.57.57 0 0 1-.57-.57.58.58 0 1 1 .57.57zm0-.93a.36.36 0 0 0-.36.36.37.37 0 0 0 .36.37.38.38 0 0 0 .37-.37.37.37 0 0 0-.37-.36zM449.01 419.67a.58.58 0 1 1 .57-.57.57.57 0 0 1-.57.57zm0-.94a.37.37 0 0 0-.36.37.36.36 0 0 0 .72 0 .37.37 0 0 0-.36-.37zM448.14 424.95a.58.58 0 0 1 0-1.15.58.58 0 0 1 0 1.15zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.37zM450.22 423.8a.57.57 0 0 1-.57-.57.58.58 0 1 1 .57.57zm0-.93a.36.36 0 0 0-.36.36.37.37 0 0 0 .36.37.38.38 0 0 0 .33-.35.37.37 0 0 0-.33-.38zM450.02 425.16a.58.58 0 1 1 .57-.58.58.58 0 0 1-.57.58zm0-.94a.37.37 0 1 0 .36.36.36.36 0 0 0-.36-.33zM449.37 421.7a.57.57 0 1 1 .58-.57.57.57 0 0 1-.58.57zm0-.93a.36.36 0 1 0 .37.36.36.36 0 0 0-.37-.36zM452.55 420.97a.56.56 0 0 1-.57-.57.57.57 0 0 1 .57-.57.58.58 0 0 1 .57.57.57.57 0 0 1-.57.57zm0-.93a.37.37 0 0 0-.37.36.38.38 0 0 0 .37.37.37.37 0 0 0 .36-.37.36.36 0 0 0-.36-.36zM443.35 419.59a.57.57 0 0 1-.58-.57.58.58 0 0 1 1.15 0 .57.57 0 0 1-.57.57zm0-.93a.36.36 0 0 0-.37.36.37.37 0 1 0 .73 0 .36.36 0 0 0-.36-.36zM441.17 418.66a.58.58 0 0 1 0-1.15.58.58 0 0 1 0 1.15zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM436.38 419.02a.57.57 0 0 1-.57-.57.56.56 0 0 1 .57-.57.57.57 0 0 1 .57.57.58.58 0 0 1-.57.57zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.37zM440.55 424.66a.58.58 0 0 1-.58-.57.58.58 0 1 1 .58.57zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.37zM424.95 425.25a.57.57 0 0 1-.58-.57.58.58 0 0 1 1.15 0 .57.57 0 0 1-.57.57zm0-.93a.36.36 0 0 0-.37.36.37.37 0 1 0 .73 0 .36.36 0 0 0-.36-.38zM427.36 423.9a.58.58 0 1 1 .57-.57.58.58 0 0 1-.57.57zm0-.94a.37.37 0 1 0 0 .73.37.37 0 0 0 0-.73zM429.42 424.58a.57.57 0 0 1-.58-.57.58.58 0 0 1 1.15 0 .57.57 0 0 1-.57.57zm0-.93a.36.36 0 0 0-.37.36.37.37 0 1 0 .73 0 .36.36 0 0 0-.36-.36zM429.78 423.15a.57.57 0 1 1 .57-.57.56.56 0 0 1-.57.57zm0-.93a.36.36 0 1 0 .36.36.36.36 0 0 0-.36-.33zM429.79 421.88a.58.58 0 0 1 0-1.15.58.58 0 0 1 0 1.15zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM430.36 426.42a.58.58 0 1 1 .58-.58.58.58 0 0 1-.58.58zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM436.07 426.55a.58.58 0 1 1 .58-.57.58.58 0 0 1-.58.57zm0-.94a.37.37 0 0 0-.36.37.37.37 0 0 0 .73 0 .37.37 0 0 0-.37-.37zM435.36 425.16a.58.58 0 1 1 .57-.58.58.58 0 0 1-.57.58zm0-.94a.37.37 0 1 0 0 .73.37.37 0 0 0 0-.73zM432.48 424.47a.58.58 0 0 1-.57-.57.57.57 0 0 1 .57-.57.56.56 0 0 1 .57.57.57.57 0 0 1-.57.57zm0-.94a.37.37 0 0 0-.36.37.36.36 0 0 0 .36.36.37.37 0 0 0 .37-.36.38.38 0 0 0-.37-.37zM438.62 422.25a.58.58 0 1 1 .57-.57.58.58 0 0 1-.57.57zm0-.94a.37.37 0 1 0 0 .73.37.37 0 0 0 0-.73zM436.01 423.8a.57.57 0 0 1-.57-.57.58.58 0 1 1 .57.57zm0-.93a.36.36 0 0 0-.36.36.37.37 0 1 0 .73 0 .36.36 0 0 0-.37-.36zM439.05 420.57a.58.58 0 1 1 .57-.58.57.57 0 0 1-.57.58zm0-.94a.36.36 0 0 0-.36.36.36.36 0 1 0 .72 0 .36.36 0 0 0-.36-.36zM438.83 419.01a.58.58 0 0 1-.58-.57.58.58 0 1 1 .58.57zm0-.94a.37.37 0 0 0-.37.37.37.37 0 0 0 .73 0 .37.37 0 0 0-.36-.37zM437.63 420.61a.58.58 0 0 1 0-1.15.58.58 0 0 1 0 1.15zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.37zM434.68 423.31a.58.58 0 1 1 .58-.57.58.58 0 0 1-.58.57zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM432.48 422.85a.58.58 0 1 1 .57-.57.57.57 0 0 1-.57.57zm0-.94a.37.37 0 0 0 0 .73.37.37 0 1 0 0-.73zM435.36 420.25a.58.58 0 0 1-.58-.57.58.58 0 1 1 .58.57zm0-.94a.38.38 0 0 0-.37.37.37.37 0 0 0 .37.36.36.36 0 0 0 .36-.36.37.37 0 0 0-.36-.43zM431.14 420.77a.37.37 0 0 1-.36-.37.36.36 0 0 1 .36-.36.37.37 0 0 1 .37.36.38.38 0 0 1-.37.37zm0-.6a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM432.25 421.49a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36zm0-.59a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM437.68 418.57a.36.36 0 0 1-.36-.36.36.36 0 1 1 .72 0 .36.36 0 0 1-.36.36zm0-.6a.24.24 0 1 0 .23.24.23.23 0 0 0-.23-.24zM438.48 424.69a.38.38 0 0 1-.37-.37.37.37 0 0 1 .37-.36.36.36 0 0 1 .36.36.37.37 0 0 1-.36.37zm0-.6a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM439.41 425.12a.37.37 0 0 1-.36-.37.37.37 0 0 1 .73 0 .37.37 0 0 1-.37.37zm0-.6a.23.23 0 1 0 .24.23.23.23 0 0 0-.24-.23zM438.27 423.67a.37.37 0 0 1-.37-.36.38.38 0 0 1 .37-.37.37.37 0 0 1 .36.37.36.36 0 0 1-.36.36zm0-.59a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM445.4 420.25a.37.37 0 0 1 0-.73.37.37 0 1 1 0 .73zm0-.6a.24.24 0 0 0 0 .47.24.24 0 1 0 0-.47zM445.85 421.25a.36.36 0 0 1-.37-.36.37.37 0 1 1 .73 0 .36.36 0 0 1-.36.36zm0-.59a.23.23 0 0 0-.24.23.24.24 0 0 0 .47 0 .23.23 0 0 0-.23-.28zM445.48 422.07a.37.37 0 0 1-.36-.37.36.36 0 0 1 .36-.36.37.37 0 0 1 .37.36.38.38 0 0 1-.37.37zm0-.6a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM444.55 424.74a.37.37 0 0 1-.37-.36.38.38 0 0 1 .37-.37.37.37 0 0 1 .36.37.36.36 0 0 1-.36.36zm0-.6a.24.24 0 1 0 0 .47.24.24 0 0 0 0-.47zM450.31 422.25a.36.36 0 0 1-.36-.36.37.37 0 0 1 .36-.37.38.38 0 0 1 .37.37.37.37 0 0 1-.37.36zm0-.59a.23.23 0 0 0-.23.23.23.23 0 0 0 .46 0 .23.23 0 0 0-.23-.24zM441.74 424.45a.36.36 0 0 1-.36-.36.37.37 0 0 1 .36-.37.38.38 0 0 1 .37.37.37.37 0 0 1-.37.36zm0-.59a.23.23 0 1 0 .24.23.23.23 0 0 0-.24-.23zM444.77 422.96a.37.37 0 0 1-.37-.36.38.38 0 0 1 .37-.37.37.37 0 0 1 .36.37.36.36 0 0 1-.36.36zm0-.59a.23.23 0 0 0-.23.23.23.23 0 1 0 .46 0 .23.23 0 0 0-.23-.23zM443.55 425.48a.36.36 0 0 1-.36-.36.37.37 0 0 1 .36-.37.38.38 0 0 1 .37.37.37.37 0 0 1-.37.36zm0-.6a.24.24 0 1 0 .24.24.24.24 0 0 0-.24-.24zM451.55 422.94a.36.36 0 1 1 0-.72.36.36 0 1 1 0 .72zm0-.59a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM446.87 419.02a.36.36 0 0 1-.36-.36.36.36 0 1 1 .72 0 .36.36 0 0 1-.36.36zm0-.6a.24.24 0 1 0 .23.24.23.23 0 0 0-.23-.24zM434.55 418.57a.37.37 0 0 1-.37-.36.38.38 0 0 1 .37-.37.37.37 0 0 1 .36.37.36.36 0 0 1-.36.36zm0-.6a.24.24 0 1 0 0 .47.24.24 0 0 0 0-.47zM424.16 421.65a.37.37 0 0 1-.37-.37.37.37 0 0 1 .73 0 .37.37 0 0 1-.36.37zm0-.6a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM433.22 419.02a.36.36 0 0 1-.36-.36.37.37 0 0 1 .36-.37.38.38 0 0 1 .37.37.37.37 0 0 1-.37.36zm0-.6a.24.24 0 1 0 .23.24.23.23 0 0 0-.23-.24zM425.11 423.33a.37.37 0 0 1-.36-.37.36.36 0 0 1 .36-.36.37.37 0 0 1 .37.36.38.38 0 0 1-.37.37zm0-.6a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM426.42 421.13a.37.37 0 1 1 .36-.36.36.36 0 0 1-.36.36zm0-.6a.24.24 0 1 0 .23.24.23.23 0 0 0-.23-.24zM419.82 422.64a.37.37 0 0 1 0-.73.37.37 0 1 1 0 .73zm0-.6a.24.24 0 1 0 .23.24.23.23 0 0 0-.23-.24zM429.05 425.84a.36.36 0 0 1 0-.72.36.36 0 1 1 0 .72zm0-.59a.23.23 0 1 0 .23.23.23.23 0 0 0-.23-.23zM431.68 425.98a.38.38 0 0 1-.37-.37.37.37 0 0 1 .37-.36.36.36 0 0 1 .36.36.37.37 0 0 1-.36.37zm0-.6a.23.23 0 0 0-.23.23.23.23 0 0 0 .23.23.23.23 0 0 0 .23-.23.24.24 0 0 0-.23-.23z",
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 420.97,
    cy: 423.7,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 423.06,
    cy: 419.68,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 425.96,
    cy: 421.5,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 424.08,
    cy: 418.89,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 434.65,
    cy: 420.84,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 425.52,
    cy: 420.41,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 424.44,
    cy: 420.28,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 426.53,
    cy: 422.45,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 442.41,
    cy: 420.77,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 446.66,
    cy: 421.6,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 445.48,
    cy: 425.24,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 447.1,
    cy: 424.02,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 442.34,
    cy: 425.53,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 441.27,
    cy: 420.74,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 437.74,
    cy: 424.89,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 444.12,
    cy: 421.71,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 441.02,
    cy: 425.81,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 428.21,
    cy: 425.24,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 445.84,
    cy: 422.66,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 452.51,
    cy: 422.17,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 450.59,
    cy: 420.48,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 443.92,
    cy: 420.04,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 431.13,
    cy: 422.66,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 448.71,
    cy: 422.07,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 442.55,
    cy: 419.71,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 447.8,
    cy: 420.71,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 444.62,
    cy: 418.58,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 442.34,
    cy: 418.21,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 431.88,
    cy: 419.23,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 434.18,
    cy: 419.5,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 428.37,
    cy: 421.6,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 440.07,
    cy: 421.71,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 441.43,
    cy: 422.03,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 433.71,
    cy: 422.39,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 437.12,
    cy: 422.76,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 433.45,
    cy: 420.15,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 441.17,
    cy: 422.76,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 440,
    cy: 422.97,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 422.2,
    cy: 419.71,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 429.26,
    cy: 420.48,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 426.82,
    cy: 418.89,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 425.85,
    cy: 422.74,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 426.99,
    cy: 420.17,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 420.29,
    cy: 421.06,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 449.3,
    cy: 420.17,
    r: 0.21,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 451.71,
    cy: 419.83,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 453.72,
    cy: 422.87,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 452.22,
    cy: 421.34,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 452.87,
    cy: 423.33,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 453.72,
    cy: 421.79,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 451.42,
    cy: 421.5,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 454.63,
    cy: 421.5,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 427.72,
    cy: 420.9,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 431.77,
    cy: 418.13,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 436.74,
    cy: 424.15,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 430.49,
    cy: 418.09,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 428.74,
    cy: 418.33,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 436.42,
    cy: 419.92,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 421.06,
    cy: 421.88,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 423.59,
    cy: 424.46,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 433.22,
    cy: 425.72,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 431.02,
    cy: 424.46,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 437.68,
    cy: 426.01,
    r: 0.29,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M429.98 418.98s-11.42.55-6 4.2 20.83 1.59 20.83 1.59 8.53-2.15 3-4.68-13.77-.94-13.77-.94-9.48 1.74-2.19 3.26c0 0 8.78.8 9.16-1s-4.94-.52-4.94-.52 2.82.63.88.94-4.13-.21-4.13-.76 2.88-1 3.72-.94 5.19-.69 6.86 1.25a.73.73 0 0 1-.27 1.15c-1.54.65-5.54 1.9-11.94.91-8.39-1.27-1.21-4.46-1.21-4.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M403.74 452.57s22.67 12.58 34.13 19.86 31.15 27.6 12.13 28.53-47.76-35.14-47.76-35.14z",
    fill: "#c37098"
  }), React.createElement("path", {
    d: "M357.23 383.47s-2.37 15.25 2.35 16.43 5.65 12.92 4 13.06 8.75 8.42 6.36 12.36 2 8.3 6.09 9.09 9.64 3.35 11.2 6.76 14.67 10.39 19.14 10.89 2.87 17.46-2.13 18.84-21-9.49-26.37-3-21.77 19.85-29.43 16.07-20.54-15.58-26.57-16.58-13.18-69.38-7.8-79.77 15.87-26.91 43.16-4.15z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M310.87 414.49c1.28 22.77 5.52 50.15 9.32 50.79 6 1 18.92 12.8 26.58 16.58s24-9.57 29.42-16.07 21.36 4.35 26.37 3 6.6-18.33 2.13-18.83-17.59-7.51-19.14-10.92-7.09-6-11.2-6.76-8.47-5.16-6.08-9.1-8-12.21-6.37-12.35c.64-.06.89-1.89.67-4.16-.35-3.55-1.81-8.19-4.69-8.91a2.82 2.82 0 0 1-1.77-1.55c-2.24-4.17-.57-14.88-.57-14.88-13.66-11.37-23.1-12.92-29.8-10.33s-10.66 9.32-13.35 14.51c-1.99 3.85-2.26 15.61-1.52 28.98z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M412.31 283.73c2-4.16-2.05-8.94-6.42-10.45s-9.26-1.26-13.47-3.18c-7.2-3.28-10.6-12-17.62-15.63-5.46-2.84-12.05-2.06-18.07-.79-8.9 1.88-19.12 6.33-20.48 15.33-.61 4.05.8 8.37-.66 12.2-3.74 9.83-20.66 6.44-26.35 15.28-1.39 2.16-1.86 4.77-2.31 7.3l-5.89 33.34c-.81 4.58-1.68 9.3-4.25 13.17-3.77 5.66-10.46 8.48-16.77 11-4.51 1.8-9.23 3.64-14.07 3.18-2.39-.22-4.93-1-7.1.06s-3.17 3.5-3.86 5.79a59.81 59.81 0 0 0-1.25 29.44c.82 3.91 2 8 .81 11.8-1.06 3.28-3.73 5.72-6.05 8.27a49.23 49.23 0 0 0-10.83 19.28c-1.56 5.35-1.92 11.86 2 15.79s10.18 3.55 15.64 3c5.73-.62 11.91-1.45 16-5.46 2.24-2.19 3.62-5.09 4.95-7.93l8.28-17.73c4.37-9.35 10-19.75 20-22.14 6.33-1.51 12.94.65 19.45.41 15.38-.56 26.84-13.83 36.26-26 1.6-2.06 3.28-4.41 3-7-.19-1.71-1.22-3.19-1.94-4.75-3.27-7.15.22-15.57 4.75-22s10.29-12.37 12.2-20c.94-3.74.87-7.67 1.64-11.45a26.24 26.24 0 0 1 13.43-17.75c5.85-3.15 15.89-5.96 18.98-12.38z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M412.31 283.73c2-4.16-2.05-8.94-6.42-10.45s-9.26-1.26-13.47-3.18c-7.2-3.28-10.6-12-17.62-15.63-5.46-2.84-12.05-2.06-18.07-.79-8.9 1.88-19.12 6.33-20.48 15.33-.61 4.05.8 8.37-.66 12.2-3.74 9.83-20.66 6.44-26.35 15.28-1.39 2.16-1.86 4.77-2.31 7.3l-5.89 33.34c-.81 4.58-1.68 9.3-4.25 13.17-3.77 5.66-10.46 8.48-16.77 11-4.51 1.8-9.23 3.64-14.07 3.18-2.39-.22-4.93-1-7.1.06s-3.17 3.5-3.86 5.79a59.81 59.81 0 0 0-1.25 29.44c.82 3.91 2 8 .81 11.8-1.06 3.28-3.73 5.72-6.05 8.27a49.23 49.23 0 0 0-10.83 19.28c-1.56 5.35-1.92 11.86 2 15.79s10.18 3.55 15.64 3c5.73-.62 11.91-1.45 16-5.46 2.24-2.19 3.62-5.09 4.95-7.93l8.28-17.73c4.37-9.35 10-19.75 20-22.14 6.33-1.51 12.94.65 19.45.41 15.38-.56 26.84-13.83 36.26-26 1.6-2.06 3.28-4.41 3-7-.19-1.71-1.22-3.19-1.94-4.75-3.27-7.15.22-15.57 4.75-22s10.29-12.37 12.2-20c.94-3.74.87-7.67 1.64-11.45a26.24 26.24 0 0 1 13.43-17.75c5.85-3.15 15.89-5.96 18.98-12.38z",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M264.03 364.25c-.61-.06-1.23-.15-1.85-.24.74 0 1.5.16 2.25.26zM253.44 457.66c5.72-.62 11.9-1.44 16-5.45 2.25-2.19 3.62-5.1 4.95-7.94q4.14-8.86 8.29-17.73c4.36-9.34 10-19.74 20-22.14 6.34-1.51 12.95.66 19.46.42 15.38-.56 26.84-13.83 36.26-26 1.59-2.06 3.28-4.42 3-7-.19-1.7-1.22-3.18-1.93-4.74-3.27-7.15.21-15.57 4.75-22s10.29-12.36 12.2-20c.93-3.74.87-7.67 1.64-11.45a26.17 26.17 0 0 1 13.42-17.75c5.78-3.13 15.81-5.93 18.9-12.35 2-4.17-2-8.94-6.42-10.45s-9.26-1.26-13.47-3.18c-7.2-3.28-10.59-12-17.62-15.64a16.72 16.72 0 0 0-5.13-1.64 17.92 17.92 0 0 1 7.05 1.86c7 3.64 10.42 12.35 17.62 15.64 4.21 1.91 9.1 1.66 13.47 3.18s8.42 6.28 6.41 10.45c-3.09 6.42-13.12 9.22-18.89 12.35a26.19 26.19 0 0 0-13.43 17.75c-.77 3.78-.7 7.7-1.64 11.45-1.91 7.62-7.66 13.56-12.2 20s-8 14.84-4.75 22c.72 1.56 1.75 3 1.94 4.75.29 2.59-1.39 4.94-3 7-9.42 12.17-20.88 25.44-36.26 26-6.51.23-13.12-1.93-19.45-.42-10 2.39-15.65 12.8-20 22.14q-4.14 8.87-8.29 17.73c-1.32 2.84-2.7 5.75-4.94 7.93-4.13 4-10.31 4.84-16 5.46a35.21 35.21 0 0 1-9.17.08 41.85 41.85 0 0 0 7.23-.31z"
  })), React.createElement("path", {
    d: "M384.55 392.15s14.34 19.47 13.49 28.26a41.22 41.22 0 0 0 1.71 16M404.97 412.07s5.93 24.84 7.86 24.84-7.86-24.84-7.86-24.84z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M631.69 630.53s-11.37 11.64-19.14 12.72-14.14 26.07-3.33 28 31.61-5.83 34.66-9.15 14.14-23 14.14-23z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M746.47 539.41s-42.33 23.29-44.92 32.53 6.28 16.63 6.28 16.63 1.48 7.95 2 13.86 7.4 63.4 10.54 68.21.55 22.92.55 22.92h10.17l-.74-27.73s-11.46-81.51-1.85-89.83 17.56-17.74 20.33-17-2.36-19.59-2.36-19.59z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M746.47 539.41s-42.33 23.29-44.92 32.53 6.28 16.63 6.28 16.63 1.48 7.95 2 13.86 7.4 63.4 10.54 68.21.55 22.92.55 22.92h10.17l-.74-27.73s-11.46-81.51-1.85-89.83 17.56-17.74 20.33-17-2.36-19.59-2.36-19.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M694.35 506.32s-27.73 53-28.28 60.16-24.12 37.71-24.12 37.71l29.39 37.15s3.88-9.42 10.53-12.75 5.27-10.81 5.27-10.81 6.93 0 11.92-8.32 11.09-16.64 11.09-20.21 36.6-41.31 36.6-41.31l-2.77-40.2-7.49-12.76z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M622.26 509.37l-.24.21c-3.37 3-41.07 36.42-41.07 37.22s-13.58 23.29 3.33 42.7 55.73 51.29 55.73 51.29 16.91 12.2 19.13 14.69 35.76 0 15.8-22.73-38.82-48.24-38.82-48.24 33.27-8 35.49-13.59-43.8-74.86-43.8-74.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M621.15 509.37l-.24.21c-3.37 3-41.07 36.42-41.07 37.22s-13.58 23.29 3.33 42.7 55.73 51.29 55.73 51.29 16.91 12.2 19.13 14.69 35.76 0 15.8-22.73-38.81-48.24-38.81-48.24 33.27-8 35.48-13.59 46-73.47 46-73.47l-89.83-1.39z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M717.08 360.25l-3.33 30.22s-34.1 13.58-34.93 13.31-22.73-20-19.13-33c1.81-6.53 2.64-15.59 3-23s.31-13.05.31-13.05 49.63-17.74 45.19-5.54c-1.61 4.42-.89 9.73.7 14.69a68.4 68.4 0 0 0 8.19 16.37z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M708.91 343.85c-.3.36-.61.69-.92 1a33.22 33.22 0 0 1-45.28 2.88c.37-7.34.31-13.05.31-13.05s49.63-17.74 45.19-5.54c-1.61 4.44-.89 9.75.7 14.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M717.08 320.93a33.26 33.26 0 1 1-33.27-33.27 33.06 33.06 0 0 1 33.27 33.27z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M676.05 391.58s-13-28.88-17.47-28.88-11.37 149.39-11.37 149.39l67.93 1.07 2.77-78.44-13.86-69.47s-12.5 27.4-28 26.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M676.05 393.8s-13-28.88-17.47-28.88-11.37 149.39-11.37 149.39l77.08 1.16-6.38-78.53-13.86-69.52s-12.5 27.45-28 26.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M676.05 392.69s-13-28.88-17.47-28.88-11.37 149.44-11.37 149.44l77.08 1.16-6.38-78.53-13.86-69.57s-12.5 27.45-28 26.38z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M663.41 354.74s-2.33-3.4-5.66-2.29-5.82-1.95-9.15 1.1-16.63 7.21-19.13 5.83-11.37 4.71-13.31 8.31-8.32 13.31-8.32 13.31-5.54 6.66-4.71 10.26-1.94 7.76-5.27 9.43-10 18.3-10 18.3 1.79 22.24-5.69 26.13-1.94 20.79-1.94 20.79l35.36-8.39 10-22.73s-3.88 66.54-8.6 72.64-5.26 10-5.26 10 18.29 3.88 22.18 7.21 14.14-.83 14.14-.83l10-88.45s3.6-16.63 3.6-25.23 1.76-55.39 1.76-55.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M662.3 354.74s-2.33-3.4-5.66-2.29-5.82-1.95-9.15 1.1-16.63 7.21-19.13 5.83-11.37 4.71-13.31 8.31-8.31 13.31-8.31 13.31-5.55 6.66-4.72 10.26-1.94 7.76-5.27 9.43-10 18.3-10 18.3 1.8 22.26-5.67 26.13c-1.87 1-2.93 3.13-3.46 5.82-2.15 10.87 6.75 20.81 17.83 20.46l19.1-7.88 10-28.73s-3.88 66.54-8.6 72.64-5.26 10-5.26 10 18.3 3.88 22.18 7.21 14.14-.83 14.14-.83l10-88.45s3.6-16.63 3.6-25.23 1.69-55.39 1.69-55.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M601.19 402.91s3.36 9.14 12.48 8.34-12.48-8.34-12.48-8.34zM610.06 389.04s6.1 1.11 8.32 6.38-8.32-6.38-8.32-6.38zM627.25 379.62c0 1.11 3.88 20.51 0 28.55s-3.32 17.47-3.32 17.47zM709.09 348.07s2.17-2.56 4.39-2.28 3.6 1.66 6.37 2.77 9.43 1.39 9.43 2.22 5.82 4.16 9.7 5 16.09 9.15 19.14 25.23 8.31 20.8 8.31 20.8l-29.39 14.44s22.74 96.45 25.51 103.38 3 48 3 48-18 8-22.73 10.54-2.78-23.84-12.48-39.09-20.79-37.43-20.79-37.43l-16.87-47.4s-10.81-63.22-1.66-74.86 18.9-27.14 18.07-31.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M710.2 348.07s2.17-2.56 4.39-2.28 3.6 1.66 6.37 2.77 9.43 1.39 9.43 2.22 5.82 4.16 9.7 5 16.08 9.15 19.13 25.23 8.32 20.8 8.32 20.8l-29.39 14.44s22.74 96.49 25.51 103.42 3 48 3 48-18 8-22.73 10.54-2.73-23.96-12.38-39.17-20.79-37.43-20.79-37.43l-16.97-47.36s-10.81-63.22-1.66-74.86 18.9-27.14 18.07-31.32z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M770.31 469.45c-.82.13-1.86.25-3.07.36-8.88.81-26.31 1-26.31 1s-13-25.78-24.13-25c0 0 10.26-11.65 14.42-10.26.7.23 1.13-.28 1.34-1.27 1.11-5-2.72-22-2.72-22l-5.27-23 30.5 7.49c2.77.55 11.36 5 11.36 5s.28 11.92 2.5 14.69 4.71 16.08 4.43 19.41 3.05 18.85-.27 23 4.16 9.47-2.78 10.58z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M771.42 469.45c-.82.13-1.86.25-3.07.36-8.88.81-26.32 1-26.32 1s-13-25.78-24.12-25c0 0 10.26-11.65 14.42-10.26.7.23 1.13-.28 1.34-1.27 1.11-5-2.73-22-2.73-22l-5.26-23 30.49 7.49c2.78.55 11.37 5 11.37 5s.28 11.92 2.5 14.69 4.71 16.08 4.43 19.41 3.05 18.85-.27 23 4.15 9.47-2.78 10.58z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M740.09 409s25.51 2.78 26.62 9.15-26.62-9.15-26.62-9.15z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M656.36 651.05s-1.66 9.15.28 15 1.66 18.57.28 23-6.1 10.54 6.65 13.31 21.35.28 21.91-1.94 3.32-11.09 1.1-16.08-3-18 1.11-25.51 1.39-19.13-2.49-20.52-10.54-4.43-10.54-4.43 7.21 13 .56 15.8-18.86 1.37-18.86 1.37z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M717.08 320.93a33.06 33.06 0 0 1-9.09 22.83.55.55 0 0 1-.08-.15c-1-2.11-1.93-4.31-1.85-6.61.09-2.8 1.7-5.32 2.22-8.08.65-3.48-.49-7-1.61-10.38-.82-2.46-2.41-5.44-5-5.14a6.19 6.19 0 0 1-1.53.17c-1.38-.21-1.65-2-1.81-3.38a15.36 15.36 0 0 0-12.53-13.15 3.91 3.91 0 0 0-2.2.14c-1 .44-1.48 1.48-2.35 2.08-2.81 1.95-6.4-1.79-9.81-1.5-2.91.24-4.68 3.22-5.88 5.88s-2.7 5.69-5.55 6.31a1.69 1.69 0 0 1-1.34-.16c-.88-.64-.27-2 .18-3 1.16-2.64.39-4.74-1-6.61a33.26 33.26 0 0 1 59.25 20.76z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M658.87 305.67c-.45 1-1.07 2.38-.17 3a1.72 1.72 0 0 0 1.34.15c2.84-.62 4.35-3.66 5.54-6.31s3-5.64 5.88-5.88c3.42-.28 7 3.45 9.81 1.5.87-.6 1.4-1.64 2.36-2.08a4 4 0 0 1 2.19-.14 15.38 15.38 0 0 1 12.54 13.15c.14 1.38.43 3.17 1.79 3.39a6.29 6.29 0 0 0 1.54-.18c2.57-.3 4.15 2.68 5 5.14 1.12 3.36 2.26 6.9 1.61 10.39-.52 2.75-2.14 5.27-2.22 8.07-.08 2.31.9 4.5 1.85 6.6s2.51 4.56 4.8 4.27c1.87-.25 2.91-2.24 3.81-3.9s2.52-3.46 4.34-2.93c.81.23 1.66.92 2.4.51a1.79 1.79 0 0 0 .7-1.21c.88-3.88-.39-8.23 1.49-11.73 1.45-2.7 4.4-4.15 6.79-6.06a19.42 19.42 0 0 0 2.63-27.8c-2.56-3-6.24-5.64-6.45-9.57-.15-3 1.87-5.75 1.89-8.75s-1.85-5.53-4-7.52a25.81 25.81 0 0 0-23.22-6.11c-2.15.51-4.31 1.32-6.51 1-2.54-.31-4.66-2-6.95-3.17a17.8 17.8 0 0 0-22.21 6c-2.63 4.08-3.65 9.42-7.57 12.29-2.58 1.88-6.27 2.58-7.69 5.44-.86 1.71-.62 3.74-.36 5.64a13.27 13.27 0 0 0 4.22 8.07c2.38 2.53 4.43 5.11 2.83 8.73z",
    fill: "#512e4e"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M626.7 726.46l-.28 54.07-9.98-.83-36.32-295.28 10.72-.32 7.57-.23 28.29 242.59z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M626.42 780.53l-9.98-.83-36.32-295.28 10.72-.32-.46 1.71 36.04 294.72z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M675.21 484.98l-36.59 292.78-6.86 1.55-5.34 1.22.28-54.07 32.16-240.37.63-.05 15.72-1.06z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M631.69 779.14l.07.17-5.34 1.22.28-54.07 32.16-240.37.63-.05 6.58 1.43-34.38 291.67z"
  }), React.createElement("path", {
    fill: "#65617d",
    d: "M758.95 665.19l-.84 68.2-3.32 12.41-33.27-261.1 7.85-.85 2.4-.26 27.18 181.6z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M758.95 665.19l-.84 68.2-3.32 12.41-33.27-261.1 7.85-.85 2.4-.26 27.18 181.6z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M758.95 665.19l-.84 68.2-28.28-247.3-.46-2.24 2.4-.26 27.18 181.6z"
  }), React.createElement("path", {
    fill: "#65617d",
    d: "M768.37 575.08l.83 171.27-4.63-.18-9.78-.37 3.88-263.04 7.46.93 3.63.45-1.39 90.94z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M768.37 575.08l.83 171.27-4.63-.18-9.78-.37 3.88-263.04 7.46.93 3.63.45-1.39 90.94z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M768.37 575.08l.83 171.27-4.63-.18 1.56-262.48 3.63.45-1.39 90.94z"
  }), React.createElement("path", {
    fill: "#65617d",
    d: "M450.92 481.93l.55-8.32 47.69.28 143.34-2.22 110.62 6.1 70.42 1.38.84 7.77-181.05 3.33-192.41-8.32z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M450.92 481.93l.55-8.32 47.69.28 143.34-2.22 110.62 6.1 70.42 1.38.84 7.77-181.05 3.33-192.41-8.32z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M451.47 473.61l141.4 6.1 230.67-.56-172.45-10.53-199.62 4.99z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M451.47 473.61l141.4 6.1 230.67-.56-172.45-10.53-199.62 4.99z"
  }), React.createElement("path", {
    d: "M638.1 464.41c0 5.61-9.81 11.22-21.92 11.22s-21.92-5.61-21.92-11.22 9.82-9.09 21.92-9.09 21.92 3.48 21.92 9.09z",
    fill: "#e8eaf2"
  }), React.createElement("path", {
    d: "M638.1 464.41c0 5.61-9.81 11.22-21.92 11.22s-21.92-5.61-21.92-11.22 9.82-9.09 21.92-9.09 21.92 3.48 21.92 9.09z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 616.18,
    cy: 464.41,
    rx: 21.92,
    ry: 10.16,
    fill: "#e8eaf2"
  }), React.createElement("ellipse", {
    cx: 616.25,
    cy: 464.79,
    rx: 13.08,
    ry: 5.27,
    opacity: 0.05
  }), React.createElement("path", {
    d: "M646.55 452.55c-.44-2.75-4.08-4.57-8.74-4.67a20.48 20.48 0 0 0-3.69.26c-6.32 1-11 4.64-10.43 8.09.44 2.73 4 4.54 8.6 4.67a19.63 19.63 0 0 0 3.84-.26c6.28-1.01 10.95-4.63 10.42-8.09zm-10.71 6.32a13.66 13.66 0 0 1-2 .19c-3.65.09-6.58-1.24-6.92-3.35-.4-2.47 2.95-5.07 7.47-5.8a14.6 14.6 0 0 1 3.26-.16c3 .21 5.36 1.47 5.66 3.32.38 2.48-2.97 5.08-7.5 5.8z",
    fill: "#f1cec8"
  }), React.createElement("path", {
    d: "M626.72 463.89a2.42 2.42 0 0 1-.53 1.45c-1.37 1.8-5.23 3.1-9.77 3.1-4.23 0-7.87-1.13-9.46-2.74a2.58 2.58 0 0 1-.85-1.81c0-2.51 4.61-4.55 10.31-4.55s10.3 2.04 10.3 4.55z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M626.72 463.89a2.42 2.42 0 0 1-.53 1.45 19.84 19.84 0 0 1-8.77 2h-2.48a19.86 19.86 0 0 1-8-1.67 2.58 2.58 0 0 1-.85-1.81c0-2.51 4.61-4.55 10.31-4.55s10.32 2.07 10.32 4.58zM637.78 447.88c0 .63-.07 1.26-.15 1.87a14.6 14.6 0 0 0-3.26.16c-4.52.73-7.87 3.33-7.47 5.8.34 2.11 3.27 3.44 6.92 3.35a18.27 18.27 0 0 1-1.56 1.84c-4.59-.13-8.16-1.94-8.6-4.67-.55-3.45 4.11-7.07 10.43-8.09a20.48 20.48 0 0 1 3.69-.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M595.03 444.25v2.84A19.91 19.91 0 0 0 614.94 467h2.48a19.91 19.91 0 0 0 19.91-19.91v-2.84z",
    fill: "#65617d"
  }), React.createElement("ellipse", {
    cx: 616.08,
    cy: 443.66,
    rx: 21.25,
    ry: 6.05,
    fill: "#65617d"
  }), React.createElement("ellipse", {
    cx: 616.18,
    cy: 443.28,
    rx: 20.14,
    ry: 5.47,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 616.25,
    cy: 443.08,
    rx: 19.68,
    ry: 5.47,
    fill: "#fdf9f9"
  }), React.createElement("path", {
    d: "M601.86 444.53a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM602.55 443.37a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.9a.35.35 0 0 0-.35.35.35.35 0 1 0 .7 0 .35.35 0 0 0-.35-.35zM601.86 441.6a.55.55 0 0 1-.55-.55.55.55 0 0 1 1.1 0 .55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM605.93 445.71a.56.56 0 0 1-.56-.55.56.56 0 1 1 .56.55zm0-.9a.35.35 0 1 0 .35.35.36.36 0 0 0-.35-.35zM622.25 444.62a.55.55 0 0 1-.56-.55.56.56 0 0 1 1.11 0 .55.55 0 0 1-.55.55zm0-.9a.36.36 0 0 0-.36.35.36.36 0 0 0 .71 0 .35.35 0 0 0-.35-.35zM625.87 446.05a.54.54 0 0 1-.55-.55.55.55 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.34.34 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.35zM626 443.72a.56.56 0 0 1-.56-.55.56.56 0 1 1 .56.55zm0-.9a.35.35 0 0 0-.36.35.36.36 0 0 0 .71 0 .35.35 0 0 0-.35-.35zM627.71 439.99a.54.54 0 0 1-.55-.55.55.55 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.34.34 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.35zM626.87 445.08a.54.54 0 0 1-.55-.55.55.55 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.34.34 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.35zM628.88 443.98a.55.55 0 0 1-.55-.55.54.54 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .7 0 .35.35 0 0 0-.35-.35zM628.68 445.25a.56.56 0 1 1 .55-.56.56.56 0 0 1-.55.56zm0-.91a.35.35 0 0 0-.35.35.34.34 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.31zM628.06 441.95a.55.55 0 0 1-.55-.55.55.55 0 1 1 1.1 0 .55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 1 0 .7 0 .35.35 0 0 0-.35-.35zM631.08 441.25a.55.55 0 1 1 0-1.1.55.55 0 1 1 0 1.1zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM622.25 439.92a.56.56 0 0 1-.56-.55.56.56 0 1 1 .56.55zm0-.9a.35.35 0 0 0-.36.35.36.36 0 0 0 .71 0 .35.35 0 0 0-.35-.35zM620.15 439.02a.56.56 0 1 1 .55-.56.56.56 0 0 1-.55.56zm0-.91a.36.36 0 1 0 .35.35.35.35 0 0 0-.35-.35zM615.55 439.37a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.91a.36.36 0 0 0 0 .71.36.36 0 0 0 0-.71zM619.55 444.81a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.91a.36.36 0 1 0 .35.36.36.36 0 0 0-.35-.36zM604.55 445.36a.55.55 0 0 1-.55-.55.56.56 0 0 1 1.11 0 .56.56 0 0 1-.56.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .35.35.35.35 0 0 0 .35-.35.34.34 0 0 0-.35-.35zM606.83 444.07a.55.55 0 0 1-.55-.55.54.54 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM608.81 444.73a.55.55 0 0 1-.55-.55.56.56 0 1 1 .55.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM609.16 443.35a.55.55 0 1 1 .56-.55.55.55 0 0 1-.56.55zm0-.9a.35.35 0 1 0 .36.35.35.35 0 0 0-.36-.35zM609.18 442.12a.55.55 0 1 1 .55-.55.56.56 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.36.36 0 0 0-.35-.32zM609.73 446.5a.55.55 0 0 1-.55-.55.54.54 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.34.34 0 0 0-.35.35.35.35 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.35zM615.24 446.63a.56.56 0 1 1 .55-.55.56.56 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.36.35.36.36 0 0 0 .71 0 .35.35 0 0 0-.35-.35zM614.55 445.25a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.91a.35.35 0 0 0-.35.35.35.35 0 0 0 .35.35.34.34 0 0 0 .35-.35.35.35 0 0 0-.35-.31zM611.77 444.62a.55.55 0 0 1-.55-.55.55.55 0 1 1 1.1 0 .55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .7 0 .35.35 0 0 0-.35-.35zM617.69 442.45a.56.56 0 0 1-.56-.55.56.56 0 1 1 .56.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM615.18 443.98a.55.55 0 0 1-.55-.55.54.54 0 0 1 .55-.55.55.55 0 0 1 .55.55.55.55 0 0 1-.55.55zm0-.9a.34.34 0 0 0-.35.35.35.35 0 0 0 .35.35.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.35zM618.1 440.86a.56.56 0 1 1 .56-.55.55.55 0 0 1-.56.55zm0-.91a.36.36 0 1 0 .36.36.36.36 0 0 0-.36-.36zM617.89 439.36a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.91a.36.36 0 0 0 0 .71.36.36 0 0 0 0-.71zM616.73 440.9a.55.55 0 0 1-.55-.55.56.56 0 0 1 1.11 0 .56.56 0 0 1-.56.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .35.35.35.35 0 0 0 .35-.35.34.34 0 0 0-.35-.35zM613.89 443.5a.55.55 0 1 1 .56-.55.55.55 0 0 1-.56.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM611.77 443.06a.56.56 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .7 0 .35.35 0 0 0-.35-.35zM614.55 440.51a.56.56 0 0 1 0-1.11.56.56 0 0 1 0 1.11zm0-.91a.36.36 0 0 0 0 .71.36.36 0 0 0 0-.71zM610.48 441.05a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 .22.22.22.22 0 0 0-.22-.22zM611.55 441.75a.34.34 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.57a.23.23 0 1 0 .22.22.22.22 0 0 0-.22-.22zM616.78 438.93a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.34.34 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.23.23 0 1 0 .22-.22zM617.55 444.83a.35.35 0 1 1 0-.7.35.35 0 0 1 0 .7zm0-.57a.22.22 0 0 0 0 .44.22.22 0 1 0 0-.44zM618.46 445.25a.36.36 0 1 1 0-.71.36.36 0 0 1 0 .71zm0-.58a.23.23 0 1 0 .22.22.22.22 0 0 0-.22-.22zM617.35 443.85a.34.34 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.57a.23.23 0 1 0 .22.22.22.22 0 0 0-.22-.25zM624.23 440.58a.35.35 0 1 1 .32-.33.35.35 0 0 1-.32.33zm0-.57a.22.22 0 1 0 .22.22.22.22 0 0 0-.22-.22zM624.66 441.47a.35.35 0 0 1 0-.7.35.35 0 0 1 0 .7zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM624.31 442.31a.36.36 0 1 1 0-.71.36.36 0 0 1 0 .71zm0-.58a.23.23 0 1 0 .22.22.22.22 0 0 0-.22-.22zM623.39 444.88a.35.35 0 0 1-.35-.35.36.36 0 0 1 .71 0 .35.35 0 0 1-.36.35zm0-.57a.22.22 0 0 0-.22.22.23.23 0 1 0 .22-.22zM628.96 442.47a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.34.34 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.23.23 0 1 0 .22-.22zM620.7 444.61a.36.36 0 0 1 0-.71.36.36 0 0 1 0 .71zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM623.62 443.17a.35.35 0 0 1-.35-.35.34.34 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.58a.23.23 0 1 0 0 .45.22.22 0 0 0 .22-.22.22.22 0 0 0-.22-.23zM622.45 445.6a.36.36 0 0 1 0-.71.36.36 0 0 1 0 .71zm0-.58a.23.23 0 1 0 0 .45.22.22 0 0 0 .22-.22.22.22 0 0 0-.22-.23zM630.12 443.15a.35.35 0 1 1 0-.7.35.35 0 0 1 0 .7zm0-.57a.22.22 0 1 0 0 .44.22.22 0 0 0 0-.44zM625.64 439.37a.35.35 0 0 1-.35-.35.36.36 0 0 1 .71 0 .36.36 0 0 1-.36.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM613.76 438.93a.35.35 0 0 1-.35-.35.35.35 0 0 1 .7 0 .35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM603.74 441.9a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.34.34 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM612.48 439.37a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.34.34 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM604.66 443.52a.35.35 0 0 1-.35-.35.36.36 0 0 1 .71 0 .36.36 0 0 1-.36.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM605.93 441.4a.35.35 0 1 1 .35-.35.36.36 0 0 1-.35.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM599.55 442.86a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.34.34 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM608.46 445.95a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.34.34 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45zM610.99 446.08a.36.36 0 0 1 0-.71.36.36 0 1 1 0 .71zm0-.58a.22.22 0 0 0-.22.23.22.22 0 0 0 .22.22.23.23 0 1 0 0-.45z",
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 600.67,
    cy: 443.88,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 602.69,
    cy: 440,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 605.48,
    cy: 441.76,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 603.67,
    cy: 439.25,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 613.86,
    cy: 441.12,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 605.05,
    cy: 440.7,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 604.02,
    cy: 440.59,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 606.03,
    cy: 442.68,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 621.35,
    cy: 441.06,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 625.44,
    cy: 441.85,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 624.3,
    cy: 445.36,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 625.87,
    cy: 444.19,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 621.28,
    cy: 445.64,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 620.24,
    cy: 441.02,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 616.84,
    cy: 445.03,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 623,
    cy: 441.96,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 620,
    cy: 445.92,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 607.65,
    cy: 445.36,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 624.65,
    cy: 442.88,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 631.08,
    cy: 442.4,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 629.23,
    cy: 440.78,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 622.8,
    cy: 440.35,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 610.47,
    cy: 442.88,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 627.42,
    cy: 442.31,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 621.48,
    cy: 440.03,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 626.55,
    cy: 440.99,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 623.47,
    cy: 438.94,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 621.28,
    cy: 438.59,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 611.19,
    cy: 439.57,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 613.41,
    cy: 439.83,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 607.81,
    cy: 441.85,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 619.09,
    cy: 441.96,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 620.39,
    cy: 442.27,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 612.96,
    cy: 442.62,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 616.25,
    cy: 442.97,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 612.7,
    cy: 440.46,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 620.15,
    cy: 442.97,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 619.02,
    cy: 443.17,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 601.86,
    cy: 440.03,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 608.66,
    cy: 440.78,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 606.31,
    cy: 439.25,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 605.37,
    cy: 442.96,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 606.47,
    cy: 440.48,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 600.02,
    cy: 441.33,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 627.99,
    cy: 440.48,
    r: 0.2,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 630.31,
    cy: 440.15,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 632.25,
    cy: 443.08,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 630.8,
    cy: 441.61,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 631.43,
    cy: 443.52,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 632.25,
    cy: 442.03,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 630.03,
    cy: 441.76,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 633.13,
    cy: 441.76,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 607.18,
    cy: 441.18,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 611.09,
    cy: 438.51,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 615.88,
    cy: 444.31,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 609.85,
    cy: 438.47,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 608.16,
    cy: 438.7,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 615.57,
    cy: 440.24,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 600.75,
    cy: 442.13,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 603.2,
    cy: 444.61,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 612.48,
    cy: 445.83,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 610.36,
    cy: 444.61,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 616.78,
    cy: 446.11,
    r: 0.28,
    fill: "#42312e",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M609.35 439.33s-11 .53-5.82 4.05 20.09 1.54 20.09 1.54 8.22-2.08 2.93-4.52-13.28-.9-13.28-.9-9.14 1.67-2.11 3.14c0 0 8.47.77 8.84-.94s-4.76-.5-4.76-.5 2.71.6.84.91-4-.21-4-.74 2.78-.94 3.58-.9 5-.67 6.62 1.21a.7.7 0 0 1-.26 1.1c-1.49.63-5.35 1.83-11.51.88-8.08-1.26-1.16-4.33-1.16-4.33zM755.34 433.96c1.67.55 11.37 3.05 13.31 8.87s-13.31-8.87-13.31-8.87z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M729.63 278.7a14.5 14.5 0 0 0 .59-2.31 14.78 14.78 0 0 0-.59 2.31zM659.43 303.25a8.87 8.87 0 0 1 .54-1.47c1.61-3.62-.44-6.2-2.83-8.63a13.22 13.22 0 0 1-4.22-8.07 21.91 21.91 0 0 1-.23-2.57 4.86 4.86 0 0 0-.52.81c-.86 1.71-.62 3.74-.36 5.64a13.27 13.27 0 0 0 4.22 8.07c1.83 1.86 3.44 3.81 3.4 6.22zM721.97 336.05c-1.82-.53-3.44 1.26-4.34 2.93s-1.94 3.65-3.81 3.89c-2.29.3-3.85-2.16-4.8-4.26s-1.93-4.29-1.86-6.6c0-.28 0-.55.08-.82a15.25 15.25 0 0 0-1.18 4.7c-.08 2.31.9 4.5 1.85 6.6s2.51 4.56 4.8 4.27c1.87-.25 2.91-2.24 3.81-3.9s2.52-3.46 4.34-2.93c.81.23 1.66.92 2.4.51a1.79 1.79 0 0 0 .7-1.21 15.48 15.48 0 0 0 .32-2.64c-.73.32-1.53-.34-2.31-.54zM733.35 317.56c-2.39 1.91-5.34 3.36-6.79 6.06a9.62 9.62 0 0 0-1 3.75c1.47-2.61 4.35-4.05 6.7-5.93a19.64 19.64 0 0 0 7-11.86 19.65 19.65 0 0 1-5.91 7.98zM708.33 327.36a20.12 20.12 0 0 0 1.05-3.42c.66-3.49-.48-7-1.6-10.39-.83-2.46-2.41-5.44-5-5.14a6.14 6.14 0 0 1-1.53.17c-1.36-.21-1.65-2-1.8-3.38a15.35 15.35 0 0 0-12.53-13.15 4 4 0 0 0-2.19.14c-1 .44-1.49 1.48-2.36 2.08-2.82 2-6.39-1.78-9.81-1.5-2.9.24-4.68 3.22-5.88 5.88s-2.7 5.69-5.54 6.31a1.68 1.68 0 0 1-1.34-.16 1 1 0 0 1-.44-.83 6.91 6.91 0 0 1-.5 1.7c-.45 1-1.07 2.38-.17 3a1.72 1.72 0 0 0 1.34.15c2.84-.62 4.35-3.66 5.54-6.31s3-5.64 5.88-5.88c3.42-.28 7 3.45 9.81 1.5.87-.6 1.4-1.64 2.36-2.08a4 4 0 0 1 2.19-.14 15.38 15.38 0 0 1 12.54 13.15c.14 1.38.43 3.17 1.79 3.39a6.29 6.29 0 0 0 1.54-.18c2.57-.3 4.15 2.68 5 5.14 1.06 3.23 2.13 6.61 1.65 9.95z"
  })), React.createElement("path", {
    d: "M726.73 443.67s-14.14 4.3-20.52 4.3-31.33-.14-31.33-.14-65.15-21.76-45.61 8S679.73 469 679.73 469s2.5.55 5.55 1.25 62 .14 63.9-2.22-22.45-24.36-22.45-24.36z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M767.24 469.81c-8.88.81-26.31 1-26.31 1s-13-25.78-24.13-25c0 0 10.26-11.65 14.42-10.26.7.23 1.13-.28 1.34-1.27 10.87 3.31 31.57 11.43 33.6 25.67.54 3.88.88 7.12 1.08 9.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M768.35 469.81c-8.88.81-26.32 1-26.32 1s-13-25.78-24.12-25c0 0 10.26-11.65 14.42-10.26.7.23 1.13-.28 1.34-1.27 10.87 3.31 31.57 11.43 33.59 25.67.55 3.88.89 7.12 1.09 9.86z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M767.24 470.84c-8.88.81-26.31 1-26.31 1s-13-25.78-24.13-24.95c0 0 10.26-11.65 14.42-10.26.7.23 1.13-.28 1.34-1.28 10.87 3.32 31.57 11.44 33.6 25.68.54 3.83.88 7.07 1.08 9.81zM690.47 544.03s25-6.1 28.83-2.78-28.83 2.78-28.83 2.78zM618.93 567.87s10.54 6.1 11.65 11.09-11.65-11.09-11.65-11.09zM661.08 680.25s14.41-2.22 18.11.19-18.11-.19-18.11-.19z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 844.03,
    cy: 714.08,
    rx: 20.49,
    ry: 2.81,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 922.52,
    cy: 722.04,
    rx: 20.49,
    ry: 2.81,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 1014.97,
    cy: 711.27,
    rx: 20.49,
    ry: 2.81,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 891.11,
    cy: 744.7,
    rx: 14.57,
    ry: 2,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 972.56,
    cy: 742.7,
    rx: 14.57,
    ry: 2,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M922.96 721.4s-28.73-94.2 4.5-131.93c24.86-28.23 53.08-24.85 65.72-21.35a23.32 23.32 0 0 1 15.07 12.52c4.42 9.53 3.62 25-27.57 43.06-52.22 30.24-55.47 71.72-55.47 71.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M988.68 581.48s-84.71 26.48-65.72 139.92M939.2 590.97s11.67 7.86 8 19.67M980.18 597.97s-7.13-7.26-15.81-3.26M946.7 634.45s-12.52-6.36-15.76 1.6M915.72 647.69s9.4-.75 9.57 3.75",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M921.8 722.15s33.66-68.46 42.9-67c4.39.71 6.42 5 7.33 9.37a27.61 27.61 0 0 1-1.83 16.67c-4.78 10.99-17.65 31.8-48.4 40.96z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M964.45 668.18s-35.33 51.23-42.15 53.47M967.7 676.18h-8.25M957.82 694.92l-12.92.56M949.96 679.93l1.4 6.73M936.21 700.42l.25 6.12",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M922.8 722.15s-33.65-68.46-42.9-67c-4.39.71-6.42 5-7.33 9.37a27.61 27.61 0 0 0 1.83 16.73c4.78 10.93 17.61 31.74 48.4 40.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M880.15 668.18s35.33 51.23 42.15 53.47M876.9 676.18h8.24M886.77 694.92l12.93.56M894.64 679.93l-1.4 6.73M908.38 700.42l-.25 6.12",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M980.55 738.14a5.83 5.83 0 0 0 2-2.89 2.56 2.56 0 0 0-1.34-2.94c-1.23-.47-2.54.38-3.53 1.24s-2.14 1.84-3.45 1.66a5.22 5.22 0 0 0 1.62-4.9 2 2 0 0 0-.45-1c-.68-.73-1.92-.41-2.73.16-2.6 1.83-3.33 5.36-3.34 8.54a16.54 16.54 0 0 1-.05-3.52 3.61 3.61 0 0 0-1.32-3.11 3.87 3.87 0 0 0-2-.47 4.16 4.16 0 0 0-3.27.92 3.27 3.27 0 0 0 .13 4 12.58 12.58 0 0 0 3.38 2.7 7.63 7.63 0 0 1 2.42 2.31 3.15 3.15 0 0 1 .18.41h7.32a20.22 20.22 0 0 0 4.43-3.11zM852.34 710.57a5.78 5.78 0 0 0 1.92-2.89 2.57 2.57 0 0 0-1.34-2.95c-1.23-.47-2.54.39-3.54 1.25s-2.13 1.84-3.44 1.66a5.26 5.26 0 0 0 1.62-4.91 2 2 0 0 0-.45-1c-.68-.73-1.92-.42-2.74.16-2.59 1.82-3.32 5.35-3.33 8.53a15.82 15.82 0 0 1 0-3.51 3.61 3.61 0 0 0-1.32-3.11 4 4 0 0 0-2-.48 4.19 4.19 0 0 0-3.26.93 3.24 3.24 0 0 0 .13 4 12.61 12.61 0 0 0 3.38 2.71 7.39 7.39 0 0 1 2.41 2.31 1.7 1.7 0 0 1 .18.41h7.33a20.73 20.73 0 0 0 4.45-3.11zM895.09 738.14a5.83 5.83 0 0 0 1.91-2.89 2.56 2.56 0 0 0-1.34-2.94c-1.23-.47-2.54.38-3.54 1.24s-2.13 1.84-3.44 1.66a5.24 5.24 0 0 0 1.62-4.9 2 2 0 0 0-.45-1c-.68-.73-1.92-.41-2.73.16-2.6 1.83-3.33 5.36-3.34 8.54a16.54 16.54 0 0 1-.05-3.52 3.61 3.61 0 0 0-1.32-3.11 3.87 3.87 0 0 0-2-.47 4.16 4.16 0 0 0-3.27.92 3.25 3.25 0 0 0 .13 4 12.58 12.58 0 0 0 3.38 2.7 7.5 7.5 0 0 1 2.41 2.31 1.7 1.7 0 0 1 .18.41h7.31a20.45 20.45 0 0 0 4.54-3.11zM1016.3 682.4s2.74 3.59-1.27 9-7.32 10-6 13.38c0 0 6-10.07 11-10.21s1.69-6.11-3.73-12.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1016.3 682.4a4.62 4.62 0 0 1 .56 1.13c4.81 5.65 7.37 10.92 2.75 11.05-4.31.13-9.47 7.82-10.71 9.77a3.81 3.81 0 0 0 .15.44s6-10.07 11-10.21 1.67-6.12-3.75-12.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1021.4 686.98c0 1.26-.14 2.29-.31 2.29s-.32-1-.32-2.29.18-.67.35-.67.28-.59.28.67z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M1023.15 688.49c-1.11.6-2.07 1-2.16.82s.75-.77 1.86-1.38.67-.16.76 0 .65-.05-.46.56z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M1001.8 682.4s-2.75 3.59 1.26 9 7.33 10 6 13.38c0 0-6.06-10.07-11-10.21s-1.68-6.11 3.74-12.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1001.8 682.4a4.23 4.23 0 0 0-.56 1.13c-4.81 5.65-7.37 10.92-2.75 11.05 4.3.13 9.47 7.82 10.7 9.77a3.73 3.73 0 0 1-.14.44s-6.06-10.07-11-10.21-1.67-6.12 3.75-12.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M996.69 686.98c0 1.26.15 2.29.32 2.29s.32-1 .32-2.29-.18-.67-.35-.67-.29-.59-.29.67z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M994.94 688.49c1.11.6 2.08 1 2.16.82s-.74-.77-1.85-1.38-.68-.16-.76 0-.66-.05.45.56z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M997.55 704.32s7.67-.24 10-1.88 11.8-3.62 12.38-1 11.53 13.14 2.87 13.21-20.14-1.35-22.45-2.75-2.8-7.58-2.8-7.58z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M1022.96 713.75c-8.66.07-20.13-1.35-22.44-2.75-1.76-1.07-2.46-4.92-2.7-6.69h-.27s.48 6.19 2.79 7.6 13.78 2.82 22.45 2.75c2.5 0 3.36-.91 3.32-2.23-.33.82-1.29 1.31-3.15 1.32z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 101.17,
    cy: 751.98,
    rx: 36.39,
    ry: 6.24,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M117.4 689.15s-50.67 26.18-24.49 57c0 0 2.46 6.73 9.59 6.22 0 0-1.43-2.6 4-4.67a26.34 26.34 0 0 0 5.47-2.91 12.82 12.82 0 0 0 4.9-6.55s10.37-13.87 2.34-39.53c0 0 1-7.26.13-8.42l-6.16 8.44s6.37 4.28 7.09 10.54c0 0-6.63-10.52-8.06-9.33-.29.25-3.06 4.62-3.06 4.62s11 7.48 11.85 17.2c0 0-6.22-13.6-12.92-15.55l-3.79 6.86s12.05 7.33 13.41 18.37c0 0-7-14-14.14-16.82l-2.82 7.24s11.61 7.39 12.68 16.57c0 0-9.72-15.35-13.22-14.87 0 0-2.18 6.81-1.89 8.9 0 0 8.21 5.49 8.36 10.88 0 0-7.58-9.57-8.75-8.94 0 0-.49 9.62 1.85 14.63 0 0-4-7.15-3.36-14.63 0 0-4 3.4-4.86 7.83 0 0-2.18-5.3 5-10.16 0 0 .68-7.49 1.5-8.41 0 0-7.77 3.79-11.08 8.46 0 0 1.22-6.95 11.76-10.4l2.68-7.34s-10.55 4.47-13.8 8.41c0 0 2.33-6.9 14.62-10.21l3.65-6.76s-9.38 3.16-13.95 6.76c0 0 3.55-5.93 15.07-8.65l3-4.23s-6.8 2.43-8.7 3.31-2.28.43-2.28.43a24.57 24.57 0 0 1 12.2-5.54s6.65-8.29 6.18-8.75z",
    fill: primaryColor
  }));
};
UndrawGettingCoffee.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawGettingCoffee;